webpackJsonp([1],{

/***/ "+5KF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+S4N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+qgV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0aTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},[(_vm.pages < _vm.width)?[_c('page',{attrs:{"p":_vm.page - 1,"prev":"true","pageFn":_vm.pageFn},on:{"click":_vm.onClick}}),_vm._v(" "),_vm._l((_vm.pages),function(n){return _c('page',{key:n,attrs:{"p":n,"active":_vm.page === n,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}})}),_vm._v(" "),_c('page',{attrs:{"p":_vm.page + 1,"next":"true","disabled":_vm.page === _vm.pages,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}})]:[_c('page',{attrs:{"p":_vm.page - 1,"prev":"true","pageFn":_vm.pageFn},on:{"click":_vm.onClick}}),_vm._v(" "),(_vm.page > 2)?_c('page',{attrs:{"p":1,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}}):_vm._e(),_vm._v(" "),(_vm.page === 4)?_c('page',{attrs:{"p":2,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}}):(_vm.page > 4)?_c('page',{attrs:{"hellip":true,"pageFn":_vm.pageFn}}):_vm._e(),_vm._v(" "),(_vm.page > 1)?_c('page',{attrs:{"p":_vm.page - 1,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}}):_vm._e(),_vm._v(" "),_c('page',{attrs:{"p":_vm.page,"active":"true","pageFn":_vm.pageFn},on:{"click":_vm.onClick}}),_vm._v(" "),(_vm.page < _vm.pages)?_c('page',{attrs:{"p":_vm.page + 1,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}}):_vm._e(),_vm._v(" "),(_vm.pages - _vm.page === 3)?_c('page',{attrs:{"p":_vm.page + 2,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}}):(_vm.pages - _vm.page > 3)?_c('page',{attrs:{"hellip":true,"pageFn":_vm.pageFn}}):_vm._e(),_vm._v(" "),(_vm.pages - _vm.page > 1)?_c('page',{attrs:{"p":_vm.pages,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}}):_vm._e(),_vm._v(" "),_c('page',{attrs:{"p":_vm.page + 1,"next":"true","disabled":_vm.page === _vm.pages,"pageFn":_vm.pageFn},on:{"click":_vm.onClick}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2HnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__("gqIx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ac103e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__("y2tr");
function injectStyle (ssrContext) {
  __webpack_require__("yHH8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81ac103e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ac103e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2T22":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3EH2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Axpc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G4wZ":
/***/ (function(module, exports, __webpack_require__) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Page = __webpack_require__("2HnJ").default

module.exports = {
  props: {
    page: {
      type: Number,
      default: 1
    },
    pages: {
      type: Number
    },
    width: {
      type: Number,
      default: 7
    },
    pageFn: {
      type: Function
    }
  },
  methods: {
    onClick: function (page) {
      this.$emit('change', page)
    }
  },
  components: { page: Page }
}


/***/ }),

/***/ "K2DY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageNotFound.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PageNotFound = ({});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb2b641","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
var PageNotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"error-page"},[_c('div',{staticClass:"alert alert-danger alert-dismissible"},[_vm._m(1),_vm._v("\n        我们无法找到你想要的页面，你可以选择"),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("返回首页")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1'),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"icon fa fa-ban"}),_vm._v(" 404 页面丢了!")])}]
var esExports = { render: PageNotFound_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_PageNotFound = (esExports);
// CONCATENATED MODULE: ./src/pages/PageNotFound.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PageNotFound,
  pages_PageNotFound,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_PageNotFound = (Component.exports);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageIndex.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PageIndex = ({
  components: {
  },
  data: function data () {
    return {
      email: '',
      password: '',
      errmsg: '',
      captchaUrl: '',
      remember: false,
      captcha: ''
    }
  },
  created: function created () {
    this.updateCaptcha()
  },
  mounted: function mounted () {
    var $this = this;
    jquery_default()('.js-checkbox').iCheck({
      checkboxClass: 'icheckbox_square-blue',
      radioClass: 'iradio_square-blue',
      increaseArea: '20%' // optional
    })
    .on('ifChecked', function (e) {
      $this.remember = true;
    })
    .on('ifUnchecked', function (e) {
      $this.remember = false;
    });
  },
  computed: {
  },
  methods: {
    updateCaptcha: function updateCaptcha () {
      var timenow = new Date().getTime();
      var url = '/captcha/mews?' + timenow;
      this.captchaUrl = url
      this.captcha = ''
    },
    showError: function showError (errmsg) {
      this.errmsg = errmsg
    },
    loginAction: function loginAction () {
      var $this = this;
      var postData = {email: this.email, password: this.password, remember: this.remember, captcha: this.captcha}
      this.$http.post('/api/login', postData)
        .then(function (resp) {
          if (resp.data.errcode !== 0) {
            $this.showError(resp.data.errmsg)
            $this.updateCaptcha()
            return
          }
          $this.$router.push('home')
        })
        .catch(function (error) {
          console.log(error);
        })
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe79ca6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageIndex.vue
var PageIndex_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page login-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-box-body"},[_c('p',{staticClass:"login-box-msg"},[_vm._v("输入你的登录凭证")]),_vm._v(" "),_c('form',{attrs:{"action":"#","method":"get"}},[_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"邮箱","autocomplete":"on","value":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-envelope form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"密码","autocomplete":"on","value":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-lock form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.captcha),expression:"captcha"}],staticClass:"form-control",attrs:{"type":"text","name":"captcha","placeholder":"验证码"},domProps:{"value":(_vm.captcha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.captcha=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"text-align":"right"}},[_c('img',{staticStyle:{"height":"34px"},attrs:{"src":_vm.captchaUrl,"title":"点击换一张验证码"},on:{"click":function($event){return _vm.updateCaptcha()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-8"},[_c('div',{staticClass:"checkbox icheck"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remember),expression:"remember"}],staticClass:"js-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.remember)?_vm._i(_vm.remember,null)>-1:(_vm.remember)},on:{"change":function($event){var $$a=_vm.remember,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.remember=$$a.concat([$$v]))}else{$$i>-1&&(_vm.remember=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.remember=$$c}}}}),_vm._v(" 记住密码\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('button',{staticClass:"btn btn-warning btn-block btn-flat",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.loginAction()}}},[_vm._v("登录")])])])]),_vm._v(" "),_c('p',{staticClass:"text-red"},[_vm._v(_vm._s(_vm.errmsg))])])])}
var PageIndex_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-logo"},[_c('a',{attrs:{"href":"#"}},[_vm._v("熊猫抓抓管理平台")])])}]
var PageIndex_esExports = { render: PageIndex_render, staticRenderFns: PageIndex_staticRenderFns }
/* harmony default export */ var pages_PageIndex = (PageIndex_esExports);
// CONCATENATED MODULE: ./src/pages/PageIndex.vue
function injectStyle (ssrContext) {
  __webpack_require__("+S4N")
}
var PageIndex_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageIndex___vue_template_functional__ = false
/* styles */
var PageIndex___vue_styles__ = injectStyle
/* scopeId */
var PageIndex___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageIndex___vue_module_identifier__ = null
var PageIndex_Component = PageIndex_normalizeComponent(
  PageIndex,
  pages_PageIndex,
  PageIndex___vue_template_functional__,
  PageIndex___vue_styles__,
  PageIndex___vue_scopeId__,
  PageIndex___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageIndex = (PageIndex_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ContentHeader = ({
  components: {
  },
  data: function data () {
    return {
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
  },
  computed: Object.assign({}, Object(vuex_esm["b" /* mapState */])({
      pageData: function (state) { return state.pageData; }
    })),
  methods: {
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b58e910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentHeader.vue
var ContentHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      "+_vm._s(_vm.pageData.title)+"\n      "),_c('small',[_vm._v(_vm._s(_vm.pageData.brief))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li'),_vm._v(" "),_vm._l((_vm.pageData.pathlist),function(nav){return _c('li',[_c('router-link',{attrs:{"to":nav.url ? nav.url : ''}},[_vm._v(" "+_vm._s(nav.name))])],1)})],2)])}
var ContentHeader_staticRenderFns = []
var ContentHeader_esExports = { render: ContentHeader_render, staticRenderFns: ContentHeader_staticRenderFns }
/* harmony default export */ var components_ContentHeader = (ContentHeader_esExports);
// CONCATENATED MODULE: ./src/components/ContentHeader.vue
function ContentHeader_injectStyle (ssrContext) {
  __webpack_require__("yyNB")
}
var ContentHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ContentHeader___vue_template_functional__ = false
/* styles */
var ContentHeader___vue_styles__ = ContentHeader_injectStyle
/* scopeId */
var ContentHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentHeader___vue_module_identifier__ = null
var ContentHeader_Component = ContentHeader_normalizeComponent(
  ContentHeader,
  components_ContentHeader,
  ContentHeader___vue_template_functional__,
  ContentHeader___vue_styles__,
  ContentHeader___vue_scopeId__,
  ContentHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentHeader = (ContentHeader_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageHome.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PageHome = ({
  components: {
    ContentHeader: src_components_ContentHeader
  },
  data: function data () {
    return {
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
  },
  computed: {
  },
  methods: {
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1d5e39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageHome.vue
var PageHome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_vm._m(0)],1)}
var PageHome_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary",staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticStyle:{"margin-top":"20px","font-size":"16px","color":"#636b6f","line-height":"34px"}},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("欢迎光临熊猫抓抓")])])])])])])])}]
var PageHome_esExports = { render: PageHome_render, staticRenderFns: PageHome_staticRenderFns }
/* harmony default export */ var pages_PageHome = (PageHome_esExports);
// CONCATENATED MODULE: ./src/pages/PageHome.vue
function PageHome_injectStyle (ssrContext) {
  __webpack_require__("rgg/")
}
var PageHome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageHome___vue_template_functional__ = false
/* styles */
var PageHome___vue_styles__ = PageHome_injectStyle
/* scopeId */
var PageHome___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageHome___vue_module_identifier__ = null
var PageHome_Component = PageHome_normalizeComponent(
  PageHome,
  pages_PageHome,
  PageHome___vue_template_functional__,
  PageHome___vue_styles__,
  PageHome___vue_scopeId__,
  PageHome___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageHome = (PageHome_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-aliplayer/dist/vue-aliplayer.js
var vue_aliplayer = __webpack_require__("KLvN");
var vue_aliplayer_default = /*#__PURE__*/__webpack_require__.n(vue_aliplayer);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageRoomList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var Pagination = __webpack_require__("u5iF").default

/* harmony default export */ var PageRoomList = ({
  components: {
    ContentHeader: src_components_ContentHeader,
    Pagination: Pagination,
    'ali-player': vue_aliplayer_default.a
  },
  data: function data () {
    return {
      searchName: '',
      searchMergeStatus: '',
      searchTecentRoomId: '',
      searchOnline: '',
      searchRateType: '',
      searchMasterPvsStatus: '',
      searchSlavePvsStatus: '',
      searchDeviceName: '',
      globalInfo: {},
      totalItems: 0,
      gameRoomList: [],
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0,
      WSURL: '',
      gameWebsocket: null,
      aliplayerSource: '',
      player: null,
      focus: {},
      connectStatus: false,
      roomReady: false,
      gameReady: false,
      responseMsgs: [],
      gameRoom: {wawaji_option: {}, device: {}, device_wawaji: {}}
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    // 获取娃娃机全局属性
    var $this = this
    vue_esm["a" /* default */].http.get(this.serviceUrl('api/wawaji/global/info')).then(function (resp) {
      if (resp.data.globalInfo) {
        $this.globalInfo = resp.data.globalInfo
      }
    })
    $this.getGameRooms(1)
  },
  computed: {
  },
  methods: {
    // 获取产品列表
    getGameRooms: function (page) {
      if ( page === void 0 ) page = 1;

      var params = {
        page: page,
        name: this.searchName,
        merge_status: this.searchMergeStatus,
        device_name: this.searchDeviceName,
        tencent_room_id: this.searchTecentRoomId,
        online: this.searchOnline,
        rate_type: this.searchRateType,
        master_pvs_status: this.searchMasterPvsStatus,
        slave_pvs_status: this.searchSlavePvsStatus
      }
      var $this = this
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/game/room/info'), {params: params}).then(function (resp) {
        var data = resp.data
        $this.gameRoomList = data.gameRoomList.data;
        $this.totalItems = data.gameRoomList.total;
        $this.currentPage = data.gameRoomList.current_page;
        $this.perPage = data.gameRoomList.per_page;
        $this.lastPage = data.gameRoomList.last_page;
      });
    },
    // 分页跳转
    pageChanged: function (page) {
      if ( page === void 0 ) page = 1;

      this.getGameRooms(page)
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getGameRooms(appointPage);
    },
    // 查看商品详情
    showGoodsDetail: function (row) {
      this.gameRoom = row;
    },
    // 视频赋值
    showVideo: function (row, type) {
      this.gameRoom = row;
      var $this = this
      jquery_default()('.js-show-video-modal').modal('show');
      jquery_default()('.js-show-video-modal').on('hide.bs.modal', function (e) {
        $this.aliplayerSource = ''
      })
      if (type === 1) {
        // 主直播流
        this.aliplayerSource = row.master_live_stream.live_rtmp_url;
      } else if (type === 2) {
        // 附直播流
        this.aliplayerSource = row.slave_live_stream.live_rtmp_url;
      }
    },
    // 游戏房间属性赋值
    editAttribute: function (row) {
      this.gameRoom = row;
      // if (!row.wawaji_option.rate_start_at || !row.wawaji_option.rate_end_at) {
      //     this.focus.success_rate_time = '1';
      // } else {
      //     this.focus.success_rate_time = '2';
      //     this.editDate = {startDate : row.wawaji_option.rate_start_at, endDate: row.wawaji_option.rate_end_at, startDateText: row.wawaji_option.rate_start_at, endDateText: row.wawaji_option.rate_end_at};
      // }
    },
    // 保存游戏房间属性
    saveAttribute: function () {
      var rateRe = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$|^0.00$|^100.00$/;
      var numRe = /^\d+$/;
      // var gearRe = /^([1-9]|10|-[1-9]|-10)$/;
      var wawajiOption = this.gameRoom.wawaji_option;
      if (!rateRe.test(wawajiOption.initial_success_rate)) {
        this.alert('初始成功率不合法', 2);
        return false;
      }
      // if (!this.wawajiOption.success_rate_time) {
      //     this.alert('请选择计算实际成功率有效时间', 2);
      //     return false;
      // }
      if (!wawajiOption.rate_type) {
        this.alert('请选择概率类型', 2);
        return false;
      }
      var params = {
        gr_wawaji_id: wawajiOption.gr_wawaji_id,
        initial_success_rate: wawajiOption.initial_success_rate,
        // success_rate_time: this.wawajiOption.success_rate_time,
        rate_type: wawajiOption.rate_type
      };
      // if (this.wawajiOption.success_rate_time == '2') {
      //     if (!this.editDate.startDateText || !this.editDate.endDateText) {
      //         this.alert('请选择有效时间', 2);
      //         return false;
      //     }
      //     params['rate_start_at'] = this.editDate.startDateText;
      //     params['rate_end_at'] = this.editDate.endDateText;
      // }
      var $this = this;
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/save/game/room/wawaji'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          jquery_default()('.js-edit-attribute-modal').modal('hide');
          $this.pageChanged(1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    // 游戏测试
    openWebSocket: function (row) {
      this.focus = row;
      this.connectStatus = false;
      this.roomReady = false;
      this.gameReady = false;
      this.responseMsgs = [];
    },
    // 获取Websocket地址
    getWSURL: function (row) {
      if (row === 'create') {
        this.connectWebSocket(this.WSURL);
        return;
      }
      var params = {
        game_room_id: row.game_room_id
      };
      var $this = this
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/websocket'), {params: params}).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.connectWebSocket($this.isHttps ? resp.data.wss_url : resp.data.ws_url);
        }
      });
    },
    // Websocket连接
    connectWebSocket: function (wsUrl) {
      var $this = this
      this.responseMsgs = [];
      var gameWebsocket = new WebSocket(wsUrl);
      gameWebsocket.onopen = function (e) {
        $this.connectStatus = true;
      };
      gameWebsocket.onclose = function (e) {
        $this.connectStatus = false;
        $this.roomReady = false;
        $this.gameReady = false;
      }
      gameWebsocket.onmessage = function (msg) {
        msg = JSON.parse(msg.data);
        $this.responseMsgs.push(msg);
        if (msg.data) {
          if (msg.data.game_session_id) {
            $this.gameReady = true;
          }
        }
        if (msg.method === 'room_ready') {
          // gameWebsocket握手成功
          $this.roomReady = true;
        } else if (msg.method === 'game_result') {
          gameWebsocket.close();
        } else if (msg.errcode) {
          gameWebsocket.close();
        }
      }
      gameWebsocket.onerror = function (event) {
        $this.alert('WebSocket连接失败', 2);
      }
      $this.gameWebsocket = gameWebsocket
    },
    // 游戏控制
    controlWebSocket: function (msg) {
      var data = {
        id: 'wowgotcha_test_player'
      };
      if (msg === 'insert_coins') {
        data['method'] = 'insert_coins';
      } else {
        data['method'] = 'control';
        data['params'] = {operation: msg};
      }
      this.gameWebsocket.send(JSON.stringify(data));
    },
    // 熊猫盒子管理
    focusOne: function (row) {
      this.gameRoom = row;
    },
    // 快速控制设备
    publishMsgFlash: function (focus, msg) {
      var data = {
        game_room_id: focus.game_room_id,
        message: msg
      };
      var $this = this
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/device/publish/msg'),
        data: data
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('发送成功', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    editVideo: function (row) {
      this.gameRoom = row
    },
    // 保存摄像头配置
    saveVideoParams: function (focus) {
      var this$1 = this;

      var numRe = /^\d+$/;
      var gearRe = /^-?\d+$/;
      if (focus.master_live_stream.resolution_width && !numRe.test(focus.master_live_stream.resolution_width)) {
        this.alert('主摄像头-分辨率宽格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.resolution_height && !numRe.test(focus.master_live_stream.resolution_height)) {
        this.alert('主摄像头-分辨率高格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.fps && !numRe.test(focus.master_live_stream.fps)) {
        this.alert('主摄像头-FPS格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.saturation && !gearRe.test(focus.master_live_stream.saturation)) {
        this.alert('主摄像头-饱和度格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.contrast && !gearRe.test(focus.master_live_stream.contrast)) {
        this.alert('主摄像头-对比度格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.brightness && !gearRe.test(focus.master_live_stream.brightness)) {
        this.alert('主摄像头-亮度格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.resolution_width && !numRe.test(focus.slave_live_stream.resolution_width)) {
        this.alert('侧摄像头-分辨率宽格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.resolution_height && !numRe.test(focus.slave_live_stream.resolution_height)) {
        this.alert('侧摄像头-分辨率高格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.fps && !numRe.test(focus.slave_live_stream.fps)) {
        this.alert('侧摄像头-FPS格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.saturation && !gearRe.test(focus.slave_live_stream.saturation)) {
        this.alert('侧摄像头-饱和度格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.contrast && !gearRe.test(focus.slave_live_stream.contrast)) {
        this.alert('侧摄像头-对比度格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.brightness && !gearRe.test(focus.slave_live_stream.brightness)) {
        this.alert('侧摄像头-亮度格式有误', 2);
        return false;
      }
      var params = {
        game_room_id: focus.game_room_id,
        // 主摄像头
        master_channel_no: focus.master_live_stream.channel_no,
        master_master_no: focus.master_live_stream.master_no,
        master_cloud_service: focus.master_live_stream.cloud_service,
        master_publish_url: jquery_default.a.trim(focus.master_live_stream.publish_url),
        master_live_rtmp_url: jquery_default.a.trim(focus.master_live_stream.live_rtmp_url),
        master_live_hls_url: jquery_default.a.trim(focus.master_live_stream.live_hls_url),
        master_live_rtsp_url: jquery_default.a.trim(focus.master_live_stream.live_rtsp_url),
        master_resolution_width: focus.master_live_stream.resolution_width,
        master_resolution_height: focus.master_live_stream.resolution_height,
        master_fps: focus.master_live_stream.fps,
        master_saturation: focus.master_live_stream.saturation,
        master_contrast: focus.master_live_stream.contrast,
        master_brightness: focus.master_live_stream.brightness,
        master_save_mode: focus.master_live_stream.save_mode,
        master_save_interval: focus.master_live_stream.save_interval,
        // 侧摄像头
        slave_channel_no: focus.slave_live_stream.channel_no,
        slave_master_no: focus.slave_live_stream.master_no,
        slave_cloud_service: focus.slave_live_stream.cloud_service,
        slave_publish_url: jquery_default.a.trim(focus.slave_live_stream.publish_url),
        slave_live_rtmp_url: jquery_default.a.trim(focus.slave_live_stream.live_rtmp_url),
        slave_live_hls_url: jquery_default.a.trim(focus.slave_live_stream.live_hls_url),
        slave_live_rtsp_url: jquery_default.a.trim(focus.slave_live_stream.live_rtsp_url),
        slave_resolution_width: focus.slave_live_stream.resolution_width,
        slave_resolution_height: focus.slave_live_stream.resolution_height,
        slave_fps: focus.slave_live_stream.fps,
        slave_saturation: focus.slave_live_stream.saturation,
        slave_contrast: focus.slave_live_stream.contrast,
        slave_brightness: focus.slave_live_stream.brightness,
        slave_save_mode: focus.slave_live_stream.save_mode,
        slave_save_interval: focus.slave_live_stream.save_interval
      };
      var $this = this
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/live/streams'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $this.pageChanged(this$1.currentPage);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    editDevice: function (row) {
      this.gameRoom = row
    },
    saveDeviceParams: function (focus) {
      var this$1 = this;

      var params = focus.device_wawaji
      var $this = this
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/devices/' + focus.device.iot_device_id),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $this.pageChanged(this$1.currentPage);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    saveRoom: function (row) {
      var self = this;
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/game/room/' + row.game_room_id),
        data: row
      }).then(function (response) {
        var resp = response.data
        if (resp.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.errmsg, 2);
        }
      });
    },
    changeStatus: function (row, status) {
      row.status = status;
      this.saveRoom(row);
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f700687","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageRoomList.vue
var PageRoomList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-solid"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("房间名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchName),expression:"searchName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"支持模糊搜索"},domProps:{"value":(_vm.searchName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("关联盒子：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchDeviceName),expression:"searchDeviceName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"支持模糊搜索"},domProps:{"value":(_vm.searchDeviceName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchDeviceName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("视频直播房间号：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTecentRoomId),expression:"searchTecentRoomId"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"支持模糊搜索"},domProps:{"value":(_vm.searchTecentRoomId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTecentRoomId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("盒子状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchOnline),expression:"searchOnline"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchOnline=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("在线")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("离线")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("房间状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchMergeStatus),expression:"searchMergeStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchMergeStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("空闲中")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("下架维护")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("游戏中")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("概率类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRateType),expression:"searchRateType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchRateType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("房间概率")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("全局概率")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("正摄状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchMasterPvsStatus),expression:"searchMasterPvsStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchMasterPvsStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("异常")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("侧摄状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchSlavePvsStatus),expression:"searchSlavePvsStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchSlavePvsStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("异常")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getGameRooms()}}},[_c('i',{staticClass:"fa fa-fw fa-search"}),_vm._v(" "),_c('span',[_vm._v("搜索")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button","data-toggle":"modal","data-target":".js-websocket-modal"},on:{"click":function($event){return _vm.openWebSocket('create')}}},[_c('i',{staticClass:"fa fa-gamepad"}),_vm._v(" "),_c('span',[_vm._v("控制端测试")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("总体("+_vm._s(_vm.totalItems)+")")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.gameRoomList),function(row){return _c('tr',{attrs:{"data-id":row.game_room_id}},[_c('td',[_vm._v(_vm._s(row.game_room_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.coins))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.device.device_title))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[(row.status == 0)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"}},[_vm._v("关闭")]):_vm._e(),_vm._v(" "),(row.status == 1)?_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button"}},[_vm._v("上架")]):_vm._e(),_vm._v(" "),(row.status == 2)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"}},[_vm._v("下架维护")]):_vm._e(),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeStatus(row, 0)}}},[_vm._v("关闭")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeStatus(row, 1)}}},[_vm._v("上架")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeStatus(row, 2)}}},[_vm._v("下架维护")])])])])]),_vm._v(" "),_c('td',[(row.game_status == 0)?_c('span',{staticClass:"label label-success"},[_vm._v("空闲")]):_vm._e(),_vm._v(" "),(row.game_status == 1)?_c('span',{staticClass:"label label-primary"},[_vm._v("游戏中")]):_vm._e()]),_vm._v(" "),_c('td',[(row.online == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("在线")]):_vm._e(),_vm._v(" "),(row.online == 0)?_c('span',{staticClass:"label label-danger"},[_vm._v("离线")]):_vm._e()]),_vm._v(" "),_c('td',[(row.device.io_board_status == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("在线")]):_vm._e(),_vm._v(" "),(row.device.io_board_status == 0)?_c('span',{staticClass:"label label-danger"},[_vm._v("离线")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.device.io_board_errcode))]),_vm._v(" "),_c('td',[_vm._v("\n                    第一段："+_vm._s(row.device_wawaji.io_first_force)),_c('br'),_vm._v("\n                    第二段："+_vm._s(row.device_wawaji.io_second_force)),_c('br'),_vm._v("\n                    第三段："+_vm._s(row.device_wawaji.io_third_force)),_c('br'),_vm._v("\n                    第四段："+_vm._s(row.device_wawaji.io_fourth_force)),_c('br'),_vm._v("\n                     中奖  ："+_vm._s(row.device_wawaji.io_reward_force)),_c('br')]),_vm._v(" "),_c('td',[_c('p',[_vm._v("视频房间号: "+_vm._s(row.master_live_stream ? row.master_live_stream.channel_no : ''))]),_vm._v(" "),_c('p',[(row.device.master_pvs_status == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("正常")]):_vm._e(),_vm._v(" "),(row.device.master_pvs_status == 0)?_c('span',{staticClass:"label label-danger"},[_vm._v("断流")]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"data-toggle":"modal"},on:{"click":function($event){return _vm.showVideo(row, 1)}}},[_vm._v(_vm._s(row.master_live_stream.master_no))])]),_vm._v(" "),_c('p',[(row.device.slave_pvs_status == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("正常")]):_vm._e(),_vm._v(" "),(row.device.slave_pvs_status == 0)?_c('span',{staticClass:"label label-danger"},[_vm._v("断流")]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"data-toggle":"modal"},on:{"click":function($event){return _vm.showVideo(row, 2)}}},[_vm._v(_vm._s(row.slave_live_stream.master_no))])])]),_vm._v(" "),_c('td',[(row.rate_type == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("房间概率")]):_vm._e(),_vm._v(" "),(row.rate_type == 2)?_c('span',{staticClass:"label label-primary"},[_vm._v("全局概率")]):_vm._e()]),_vm._v(" "),(row.rate_type == 1)?_c('td',[_vm._v(_vm._s(row.room_rate)+"%")]):_vm._e(),_vm._v(" "),(row.rate_type == 2)?_c('td',[_vm._v(_vm._s(_vm.globalInfo.initial_success_rate)+"%")]):_vm._e(),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".js-goods-detail-modal"},on:{"click":function($event){return _vm.showGoodsDetail(row)}}},[_vm._v(_vm._s(row.goods_name))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[_vm._m(2,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('li',[_c('a',{attrs:{"data-toggle":"modal","data-target":".js-edit-attribute-modal"},on:{"click":function($event){return _vm.editAttribute(row)}}},[_vm._v("概率设置")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"modal","data-target":".js-edit-video-modal"},on:{"click":function($event){return _vm.editVideo(row)}}},[_vm._v("摄像头参数")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"modal","data-target":".js-edit-device-modal"},on:{"click":function($event){return _vm.editDevice(row)}}},[_vm._v("娃娃机参数")])]),_vm._v(" "),(row.iot_device_id > 0)?_c('li',[_c('a',{attrs:{"data-toggle":"modal","data-target":".js-publish-msg-modal"},on:{"click":function($event){return _vm.focusOne(row)}}},[_vm._v("盒子控制")])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{attrs:{"data-toggle":"modal","data-target":".js-websocket-modal"},on:{"click":function($event){return _vm.openWebSocket(row)}}},[_vm._v("控制端测试")])])])])])])}),_vm._v(" "),_vm._m(3)],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer clearfix"},[_c('pagination',{attrs:{"page":_vm.currentPage,"pages":_vm.lastPage,"width":10,"pageFn":_vm.pageFn},on:{"change":_vm.pageChanged}}),_vm._v(" "),_c('div',{staticClass:"box-tools box-footer-appoint"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appointPage),expression:"appointPage"}],staticClass:"form-control pull-right",attrs:{"type":"number","placeholder":"指定页"},domProps:{"value":(_vm.appointPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appointPage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.pageJumped()}}},[_vm._v("跳转")])])])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-goods-detail-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("商品详情 - "+_vm._s(_vm.gameRoom.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("商品ID：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.goods_id))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("商品名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.goods_name))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("商品简介：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.goods_brief))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-edit-attribute-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("概率控制 - "+_vm._s(_vm.gameRoom.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("全局初始成功率：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('div',{staticClass:"input-group"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.globalInfo.initial_success_rate)+"%")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("房间初始成功率：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.wawaji_option.initial_success_rate),expression:"gameRoom.wawaji_option.initial_success_rate"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"单位：%"},domProps:{"value":(_vm.gameRoom.wawaji_option.initial_success_rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.wawaji_option, "initial_success_rate", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("概率类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.wawaji_option.rate_type),expression:"gameRoom.wawaji_option.rate_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.gameRoom.wawaji_option, "rate_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.gameRoom.wawaji_option.rate_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("房间概率")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("全局概率")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveAttribute()}}},[_vm._v("保存")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-show-video-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("在线预览摄像头视频 - "+_vm._s(_vm.gameRoom.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[(_vm.aliplayerSource)?_c('ali-player',{ref:"player",staticClass:"col-xs-12",attrs:{"aliplayerSdkPath":"//g.alicdn.com/de/prismplayer/2.7.1/aliplayer-min.js","source":_vm.aliplayerSource,"autoplay":true,"isLive":true,"playsinline":true,"width":"100%","height":"667px","controlBarVisibility":"always","useH5Prism":false,"useFlashPrism":true}}):_vm._e()],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-websocket-modal",attrs:{"tabindex":"-1","role":"dialog","data-backdrop":"static","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("控制端测试"),( _vm.focus != 'create' )?_c('span',[_vm._v(" - (ID:"+_vm._s(_vm.focus.game_room_id)+")")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"editDevice"}},[_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.focus == 'create'),expression:"focus == 'create'"}],staticClass:"form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.WSURL),expression:"WSURL"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"请填写WebSocket地址"},domProps:{"value":(_vm.WSURL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.WSURL=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-4 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getWSURL(_vm.focus)}}},[_vm._v("连接Websocket")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-offset-3 col-xs-3 control-label"},[_vm._v("连接状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[(!_vm.connectStatus)?_c('p',{staticClass:"form-control-static text-yellow"},[_vm._v("未连接")]):_vm._e(),_vm._v(" "),(_vm.connectStatus)?_c('p',{staticClass:"form-control-static text-green"},[_vm._v("连接成功")]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.roomReady),expression:"!roomReady"}],staticClass:"form-group"},[_c('label',{staticClass:"col-xs-offset-3 col-xs-3 control-label"},[_vm._v("房间准备：")]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.roomReady),expression:"roomReady"}]},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.controlWebSocket('u')},"mouseup":function($event){return _vm.controlWebSocket('ur')}}},[_vm._v("上")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.controlWebSocket('l')},"mouseup":function($event){return _vm.controlWebSocket('lr')}}},[_vm._v("左")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.controlWebSocket('r')},"mouseup":function($event){return _vm.controlWebSocket('rr')}}},[_vm._v("右")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":_vm.gameReady},on:{"click":function($event){return _vm.controlWebSocket('insert_coins')}}},[_vm._v("投币")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){return _vm.controlWebSocket('g')}}},[_vm._v("下抓")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.controlWebSocket('d')},"mouseup":function($event){return _vm.controlWebSocket('dr')}}},[_vm._v("下")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},_vm._l((_vm.responseMsgs),function(row){return _c('div',{staticClass:"col-xs-12"},[_c('pre',{staticClass:"form-control",staticStyle:{"height":"50px","text-align":"left"}},[_vm._v(_vm._s(row))])])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-publish-msg-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("熊猫盒子控制 - "+_vm._s(_vm.gameRoom.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'UP')},"mouseup":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'UPrelease')}}},[_vm._v("上")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'LEFT')},"mouseup":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'LEFTrelease')}}},[_vm._v("左")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'RIGHT')},"mouseup":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'RIGHTrelease')}}},[_vm._v("右")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'COIN#1')}}},[_vm._v("投币")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'GRAB')}}},[_vm._v("下抓")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"mousedown":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'DOWN')},"mouseup":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'DOWNrelease')}}},[_vm._v("下")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-offset-2 col-xs-2"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'CATCH#0')}}},[_vm._v("弱抓 ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-offset-1 col-xs-2"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'CATCH#1')}}},[_vm._v("强抓 ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-3"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'REBOOT')}}},[_vm._v("重启熊猫盒子")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'REBOOTCAMERA1')}}},[_vm._v("重启主摄像头")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'REBOOTCAMERA2')}}},[_vm._v("重启侧摄像头")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.publishMsgFlash(_vm.gameRoom, 'RECONNECT')}}},[_vm._v("重新联网")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-edit-video-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("摄像头参数 - 游戏房间 "+_vm._s(_vm.gameRoom.game_room_id))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"master"}},[(_vm.gameRoom && _vm.gameRoom.master_live_stream)?_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("直播房间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.master_live_stream.channel_no))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("主播编号：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.master_live_stream.master_no))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("推流地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.publish_url),expression:"gameRoom.master_live_stream.publish_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.gameRoom.master_live_stream.publish_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "publish_url", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("RTMP播放地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.live_rtmp_url),expression:"gameRoom.master_live_stream.live_rtmp_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.gameRoom.master_live_stream.live_rtmp_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "live_rtmp_url", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("HLS播放地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.live_hls_url),expression:"gameRoom.master_live_stream.live_hls_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.gameRoom.master_live_stream.live_hls_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "live_hls_url", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("分辨率宽：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.resolution_width),expression:"gameRoom.master_live_stream.resolution_width"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.resolution_width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "resolution_width", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("分辨率高：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.resolution_height),expression:"gameRoom.master_live_stream.resolution_height"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.resolution_height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "resolution_height", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("FPS：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.fps),expression:"gameRoom.master_live_stream.fps"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.fps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "fps", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("饱和度%：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.saturation),expression:"gameRoom.master_live_stream.saturation"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.saturation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "saturation", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("对比度%：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.contrast),expression:"gameRoom.master_live_stream.contrast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.contrast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "contrast", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("亮度%：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.brightness),expression:"gameRoom.master_live_stream.brightness"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.brightness)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "brightness", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("自动休眠：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.save_mode),expression:"gameRoom.master_live_stream.save_mode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.gameRoom.master_live_stream, "save_mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("关闭")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("开启")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("休眠间隔：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.master_live_stream.save_interval),expression:"gameRoom.master_live_stream.save_interval"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.master_live_stream.save_interval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.master_live_stream, "save_interval", $event.target.value)}}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"slave"}},[(_vm.gameRoom && _vm.gameRoom.slave_live_stream)?_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("直播房间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.slave_live_stream.channel_no))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("主播编号：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.gameRoom.slave_live_stream.master_no))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("推流地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.publish_url),expression:"gameRoom.slave_live_stream.publish_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.gameRoom.slave_live_stream.publish_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "publish_url", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("RTMP播放地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.live_rtmp_url),expression:"gameRoom.slave_live_stream.live_rtmp_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.gameRoom.slave_live_stream.live_rtmp_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "live_rtmp_url", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("HLS播放地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.live_hls_url),expression:"gameRoom.slave_live_stream.live_hls_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.gameRoom.slave_live_stream.live_hls_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "live_hls_url", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("分辨率宽：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.resolution_width),expression:"gameRoom.slave_live_stream.resolution_width"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.resolution_width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "resolution_width", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("分辨率高：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.resolution_height),expression:"gameRoom.slave_live_stream.resolution_height"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.resolution_height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "resolution_height", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("FPS：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.fps),expression:"gameRoom.slave_live_stream.fps"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.fps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "fps", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("饱和度%：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.saturation),expression:"gameRoom.slave_live_stream.saturation"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.saturation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "saturation", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("对比度%：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.contrast),expression:"gameRoom.slave_live_stream.contrast"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.contrast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "contrast", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("亮度%：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.brightness),expression:"gameRoom.slave_live_stream.brightness"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.brightness)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "brightness", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("自动休眠：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.save_mode),expression:"gameRoom.slave_live_stream.save_mode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.gameRoom.slave_live_stream, "save_mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("关闭")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("开启")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("休眠间隔：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.slave_live_stream.save_interval),expression:"gameRoom.slave_live_stream.save_interval"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.slave_live_stream.save_interval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.slave_live_stream, "save_interval", $event.target.value)}}})])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveVideoParams(_vm.gameRoom)}}},[_vm._v("保存")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-edit-device-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("娃娃机设置 - "+_vm._s(_vm.gameRoom.device.device_name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"device-first"}},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("天车位置：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.claw_position),expression:"gameRoom.device_wawaji.claw_position"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.gameRoom.device_wawaji, "claw_position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("左前")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("左后")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("右前")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("右后")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("出物口位置：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.doll_exit_position),expression:"gameRoom.device_wawaji.doll_exit_position"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.gameRoom.device_wawaji, "doll_exit_position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("左前")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("左后")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("右前")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("右后")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("天车放线时间（毫秒）：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.claw_down_times),expression:"gameRoom.device_wawaji.claw_down_times"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.claw_down_times)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "claw_down_times", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("天车前后速度：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.front_back_speed),expression:"gameRoom.device_wawaji.front_back_speed"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.front_back_speed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "front_back_speed", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("天车左右速度：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.left_right_speed),expression:"gameRoom.device_wawaji.left_right_speed"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.left_right_speed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "left_right_speed", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("天车上下速度：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.up_down_speed),expression:"gameRoom.device_wawaji.up_down_speed"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.up_down_speed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "up_down_speed", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade in",attrs:{"id":"device-second"}},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("自动调节抓力：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.auto_adjust_force),expression:"gameRoom.device_wawaji.auto_adjust_force"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.gameRoom.device_wawaji, "auto_adjust_force", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("关闭")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("开启")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("绝对值")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第一段抓力：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.first_claw_force),expression:"gameRoom.device_wawaji.first_claw_force"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.first_claw_force)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "first_claw_force", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("实时："+_vm._s(_vm.gameRoom.device_wawaji.io_first_force))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第二段抓力：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.second_claw_force),expression:"gameRoom.device_wawaji.second_claw_force"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.second_claw_force)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "second_claw_force", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("实时："+_vm._s(_vm.gameRoom.device_wawaji.io_second_force))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第三段抓力：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.third_claw_force),expression:"gameRoom.device_wawaji.third_claw_force"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.third_claw_force)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "third_claw_force", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("实时："+_vm._s(_vm.gameRoom.device_wawaji.io_third_force))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第四段抓力：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.fourth_claw_force),expression:"gameRoom.device_wawaji.fourth_claw_force"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.fourth_claw_force)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "fourth_claw_force", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("实时："+_vm._s(_vm.gameRoom.device_wawaji.io_fourth_force))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第一段抓力时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.first_claw_millisecond),expression:"gameRoom.device_wawaji.first_claw_millisecond"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.first_claw_millisecond)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "first_claw_millisecond", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第二段抓力时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.second_claw_millisecond),expression:"gameRoom.device_wawaji.second_claw_millisecond"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.second_claw_millisecond)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "second_claw_millisecond", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第三段抓力时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.third_claw_millisecond),expression:"gameRoom.device_wawaji.third_claw_millisecond"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.third_claw_millisecond)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "third_claw_millisecond", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整第四段抓力时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gameRoom.device_wawaji.fourth_claw_millisecond),expression:"gameRoom.device_wawaji.fourth_claw_millisecond"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gameRoom.device_wawaji.fourth_claw_millisecond)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gameRoom.device_wawaji, "fourth_claw_millisecond", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveDeviceParams(_vm.gameRoom)}}},[_vm._v("保存")])])])])])])])])],1)}
var PageRoomList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("房间ID")]),_vm._v(" "),_c('th',[_vm._v("房间名称")]),_vm._v(" "),_c('th',[_vm._v("游戏单价")]),_vm._v(" "),_c('th',[_vm._v("关联盒子")]),_vm._v(" "),_c('th',[_vm._v("房间状态")]),_vm._v(" "),_c('th',[_vm._v("游戏状态")]),_vm._v(" "),_c('th',[_vm._v("盒子状态")]),_vm._v(" "),_c('th',[_vm._v("IO板状态")]),_vm._v(" "),_c('th',[_vm._v("错误码")]),_vm._v(" "),_c('th',[_vm._v("天车电压")]),_vm._v(" "),_c('th',[_vm._v("视频")]),_vm._v(" "),_c('th',[_vm._v("概率类型")]),_vm._v(" "),_c('th',[_vm._v("当前概率")]),_vm._v(" "),_c('th',[_vm._v("商品名称")]),_vm._v(" "),_c('th',[_vm._v("操作")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',[_vm._v("操作 ")]),_vm._v(" "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"15"}},[_c('h1',{staticStyle:{"height":"60px"}},[_vm._v(" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3"},[_c('p',{staticClass:"form-control-static text-yellow"},[_vm._v("未准备")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs",attrs:{"id":"myTab"}},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#master","data-toggle":"tab"}},[_vm._v("主摄像头")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#slave","data-toggle":"tab"}},[_vm._v("侧摄像头")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#device-first","data-toggle":"tab"}},[_vm._v("基础")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#device-second","data-toggle":"tab"}},[_vm._v("抓力")])])])}]
var PageRoomList_esExports = { render: PageRoomList_render, staticRenderFns: PageRoomList_staticRenderFns }
/* harmony default export */ var pages_PageRoomList = (PageRoomList_esExports);
// CONCATENATED MODULE: ./src/pages/PageRoomList.vue
function PageRoomList_injectStyle (ssrContext) {
  __webpack_require__("XYxu")
}
var PageRoomList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageRoomList___vue_template_functional__ = false
/* styles */
var PageRoomList___vue_styles__ = PageRoomList_injectStyle
/* scopeId */
var PageRoomList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageRoomList___vue_module_identifier__ = null
var PageRoomList_Component = PageRoomList_normalizeComponent(
  PageRoomList,
  pages_PageRoomList,
  PageRoomList___vue_template_functional__,
  PageRoomList___vue_styles__,
  PageRoomList___vue_scopeId__,
  PageRoomList___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageRoomList = (PageRoomList_Component.exports);

// EXTERNAL MODULE: ./node_modules/bootstrap-daterangepicker/daterangepicker.js
var daterangepicker = __webpack_require__("Ikg0");
var daterangepicker_default = /*#__PURE__*/__webpack_require__.n(daterangepicker);

// EXTERNAL MODULE: ./node_modules/bootstrap-daterangepicker/daterangepicker.css
var bootstrap_daterangepicker_daterangepicker = __webpack_require__("2T22");
var bootstrap_daterangepicker_daterangepicker_default = /*#__PURE__*/__webpack_require__.n(bootstrap_daterangepicker_daterangepicker);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DateRangePicker.vue
//
//
//
//






var events = {'show-daterangepicker': 'show.daterangepicker', 'hide-daterangepicker': 'hide.daterangepicker', 'showCalendar-daterangepicker': 'showCalendar.daterangepicker', 'hideCalendar-daterangepicker': 'hideCalendar.daterangepicker', 'apply-daterangepicker': 'apply.daterangepicker', 'cancel-daterangepicker': 'cancel.daterangepicker'}

/* harmony default export */ var DateRangePicker = ({
  name: 'date-range-picker',
  components: {
  },
  props: {
    value: {
      default: null,
      required: true,
      validator: function validator (value) {
        return value instanceof Object || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof moment_default.a
      }
    },
    options: {
      type: Object,
      default: function () { return ({}); }
    }
  },
  data: function data () {
    return {
      drp: null,
      // jQuery DOM
      elem: null
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    // Return early if date-picker is already loaded
    /* istanbul ignore if */
    if (this.drp) return
    this.elem = jquery_default()(this.$el)
    // Init date-range-picker
    var $this = this
    this.elem.daterangepicker(this.options, this.onChange)
    // Store data control
    this.drp = this.elem.data('daterangepicker')
    // Register remaining events
    this.registerEvents()

    this.onChange(this.drp.startDate, this.drp.endDate)
  },
  /**
   * Free up memory
   */
  beforeDestroy: function beforeDestroy () {
    /* istanbul ignore else */
    if (this.drp) {
      this.drp = null;
      this.elem = null;
    }
  },
  watch: {
    /**
     * Listen to change from outside of component and update DOM
     *
     * @param newValue
     */
    value: function value (newValue) {
      if (this.drp) {
        if (this.options.singleDatePicker === true) {
          if (newValue.startDate) {
            this.drp.setStartDate(newValue.startDate || null)
          } else {
            this.elem.val('')
          }
        } else {
          if (newValue.startDate && newValue.endDate) {
            this.drp.setStartDate(newValue.startDate || null)
            this.drp.setEndDate(newValue.endDate || null)
          } else {
            this.elem.val('')
          }
        }
      }
    },

    /**
     * Watch for any change in options and set them
     *
     * @param newOptions Object
     */
    options: {
      deep: true,
      handler: function handler (newOptions) {
        this.elem.daterangepicker(newOptions, this.onChange);
        this.drp = this.elem.data('daterangepicker');
      }
    }
  },
  computed: {
  },
  methods: {
    /**
     * Update v-model upon change triggered by date-picker itself
     *
     * @param event
     */
    onChange: function onChange (start, end, label) {
      this.value.startDate = start
      this.value.startDateText = start.format(this.options.locale.format)
      if (this.options.singleDatePicker !== true) {
        this.value.endDate = end
        this.value.endDateText = end.format(this.options.locale.format)
      }
    },
    onCancel: function onCancel (e, picker) {
      this.elem.val('')
      this.value.startDate = ''
      this.value.startDateText = ''
      if (this.options.singleDatePicker !== true) {
        this.value.endDate = ''
        this.value.endDateText = ''
      }
    },
    /**
     * Emit all available events
     */
    registerEvents: function registerEvents () {
      var this$1 = this;

      var $this = this
      var loop = function ( key ) {
        var event = events[key]
        $this.elem.on(event, function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          if (key === 'cancel-daterangepicker') {
            $this.onCancel(args)
          } else if (key === 'apply-daterangepicker') {
            $this.onChange(this$1.drp.startDate, this$1.drp.endDate)
          }
          $this.$emit.apply($this, [ key ].concat( args ));
        });
      };

      for (var key in events) loop( key );
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726094d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateRangePicker.vue
var DateRangePicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","name":"vue-datefilter","value":"","clearable":"true"}})}
var DateRangePicker_staticRenderFns = []
var DateRangePicker_esExports = { render: DateRangePicker_render, staticRenderFns: DateRangePicker_staticRenderFns }
/* harmony default export */ var components_DateRangePicker = (DateRangePicker_esExports);
// CONCATENATED MODULE: ./src/components/DateRangePicker.vue
function DateRangePicker_injectStyle (ssrContext) {
  __webpack_require__("vIuB")
}
var DateRangePicker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DateRangePicker___vue_template_functional__ = false
/* styles */
var DateRangePicker___vue_styles__ = DateRangePicker_injectStyle
/* scopeId */
var DateRangePicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DateRangePicker___vue_module_identifier__ = null
var DateRangePicker_Component = DateRangePicker_normalizeComponent(
  DateRangePicker,
  components_DateRangePicker,
  DateRangePicker___vue_template_functional__,
  DateRangePicker___vue_styles__,
  DateRangePicker___vue_scopeId__,
  DateRangePicker___vue_module_identifier__
)

/* harmony default export */ var src_components_DateRangePicker = (DateRangePicker_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageRoomTrigger.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var PageRoomTrigger_Pagination = __webpack_require__("u5iF").default

/* harmony default export */ var PageRoomTrigger = ({
  components: {
    ContentHeader: src_components_ContentHeader,
    Pagination: PageRoomTrigger_Pagination,
    DateRangePicker: src_components_DateRangePicker
  },
  data: function data () {
    return {
      searchName: '',
      searchDataType: '',
      searchStatus: '',
      newOne: {date_scope: {}, trigger_term: {}},
      newDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      editDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      globalInfo: {},
      gameRoomList: [],
      triggerList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0,
      trigger: {date_scope: {}, trigger_term: {}}
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    // 获取娃娃机全局属性
    var $this = this
    vue_esm["a" /* default */].http.get(this.serviceUrl('api/wawaji/global/info'), {params: {search_type: 'all'}}).then(function (resp) {
      $this.globalInfo = resp.data.globalInfo;
    })
    // 获取所有房间信息
    vue_esm["a" /* default */].http.get(this.serviceUrl('api/game/room/info'), {params: {search_type: 'all'}}).then(function (resp) {
      $this.gameRoomList = resp.data.gameRoomList;
    })
    // 搜索
    $this.getTriggerList();
  },
  computed: {
  },
  methods: {
    // 获取触发器列表
    getTriggerList: function (page) {
      if ( page === void 0 ) page = 1;

      var $this = this
      var params = {
        page: page,
        name: this.searchName,
        data_type: this.searchDataType,
        status: this.searchStatus
      }
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/get/trigger/list'), {params: params}).then(function (resp) {
        var data = resp.data
        $this.triggerList = data.triggerList.data;
        $this.totalItems = data.triggerList.total;
        $this.currentPage = data.triggerList.current_page;
        $this.perPage = data.triggerList.per_page;
        $this.lastPage = data.triggerList.last_page;
      })
    },
    // 分页跳转
    pageChanged: function (page) {
      if ( page === void 0 ) page = 1;

      this.getTriggerList(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getTriggerList(appointPage);
    },
    // 获取全局信息
    getGlobalData: function () {
      this.trigger = this.globalInfo;
    },
    // 修改状态
    changeStatus: function (row, type) {
      var params = {};
      params.trigger_id = row.trigger_id;
      params.type = type;
      var $this = this
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/change/trigger/status'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('操作成功', 1);
          row.status = type;
          $this.pageChanged();
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    },
    // 点击数据类型赋值
    showByDataType: function (row) {
      this.trigger = row;
    },
    // 编辑触发器赋值
    editTrigger: function (row) {
      this.trigger = row;
      if (row.data_type === '1') {
        this.trigger.trigger_term = {};
      } else if (row.data_type === '2') {
        this.trigger.date_scope = {};
      }
      if (row.data_type === '1' && row.date_scope) {
        this.editDate = {startDate: row.date_scope.start_time, endDate: row.date_scope.end_time, startDateText: row.date_scope.start_time, endDateText: row.date_scope.end_time};
      } else {
        this.editDate = {startDate: '', endDate: '', startDateText: '', endDateText: ''};
      }
    },
    // 保存触发器
    saveTrigger: function (focus, saveType) {
      var numIntegerRe = /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/;
      var rateRe = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$|^0.00$|^100.00$/;
      var $this = this
      if (!jquery_default.a.trim(focus.name)) {
        $this.alert('名称不能为空', 2);
        return false;
      }
      if (!focus.data_type) {
        $this.alert('请选择数据类型', 2);
        return false;
      }
      if (!focus.prob_type) {
        $this.alert('请选择概率调整类型', 2);
        return false;
      }
      if (!rateRe.test(focus.change_rate)) {
        $this.alert('调整概率数值不合法', 2);
        return false;
      }
      var params = {
        name: jquery_default.a.trim(focus.name),
        data_type: focus.data_type,
        prob_type: focus.prob_type,
        change_rate: jquery_default.a.trim(focus.change_rate),
        save_type: saveType
      };
      if (focus.data_type === '1') {
        if (!(focus.date_scope && focus.date_scope.repeat_type)) {
          $this.alert('请选择重复类型', 2);
          return false;
        }
        if (focus.game_room_id === '') {
          $this.alert('请绑定房间', 2);
          return false;
        }
        params['game_room_id'] = focus.game_room_id;
        params['repeat_type'] = focus.date_scope.repeat_type;
      } else if (focus.data_type === '2') {
        // 奖品数量
        if (!focus.trigger_term.opt && focus.trigger_term.opt !== '0') {
          $this.alert('请选择运算符号', 2);
          return false;
        }
        if (!numIntegerRe.test(focus.trigger_term.data_value)) {
          $this.alert('奖品数量请填写整数', 2);
          return false;
        }
        params['opt'] = focus.trigger_term.opt;
        params['data_value'] = focus.trigger_term.data_value;
      }
      if (saveType === 'add') {
        if (focus.data_type === '1') {
          // 时间段
          if (!this.newDate.startDateText || !this.newDate.endDateText) {
            $this.alert('请填写有效时间', 2);
            return false;
          }
          params['start_at'] = this.newDate.startDateText;
          params['end_at'] = this.newDate.endDateText;
        }
      } else if (saveType === 'edit') {
        params['trigger_id'] = focus.trigger_id;
        if (focus.data_type === '1') {
          if (!this.editDate.startDateText || !this.editDate.endDateText) {
            $this.alert('请选择有效时间', 2);
            return false;
          }
          params['start_at'] = this.editDate.startDateText;
          params['end_at'] = this.editDate.endDateText;
        }
      }
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/save/trigger/info'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          if (saveType === 'add') {
            $this.alert('新增成功', 1);
            jquery_default()('.js-add-trigger-modal').modal('hide');
            $this.getTriggerList();
          } else {
            $this.alert('保存成功', 1);
            jquery_default()('.js-edit-trigger-modal').modal('hide');
            $this.pageChanged();
          }
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    },
    // 保存全局信息
    saveGlobalInfo: function (row) {
      var numRe = /^\d+$/;
      var rateRe = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$|^0.00$|^100.00$/;
      var $this = this
      if (!numRe.test(row.base_prize_amount)) {
        $this.alert('初始奖品池数量不合法', 2);
        return false;
      }
      if (!rateRe.test(row.expected_gold_rate)) {
        $this.alert('奖品池期望中奖率不合法', 2);
        return false;
      }
      if (!rateRe.test(row.initial_success_rate)) {
        $this.alert('全局初始成功率不合法', 2);
        return false;
      }
      var params = {};
      params.base_prize_amount = row.base_prize_amount;
      params.expected_gold_rate = row.expected_gold_rate;
      params.initial_success_rate = row.initial_success_rate;
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/save/wawaji/global/info'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          jquery_default()('.js-edit-global-modal').modal('hide');
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c931d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageRoomTrigger.vue
var PageRoomTrigger_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-solid"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchName),expression:"searchName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.searchName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("数据类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchDataType),expression:"searchDataType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchDataType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("时间段")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("数据池数量")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("用户是否存在手动充值")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchStatus),expression:"searchStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("启用")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("禁用")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getTriggerList()}}},[_c('i',{staticClass:"fa fa-fw fa-search"}),_vm._v(" "),_c('span',[_vm._v("搜索")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button","data-toggle":"modal","data-target":".js-edit-global-modal"},on:{"click":function($event){return _vm.getGlobalData()}}},[_c('i',{staticClass:"fa fa-asterisk"}),_vm._v(" "),_c('span',[_vm._v("全局设置")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("总体("+_vm._s(_vm.totalItems)+")")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._m(1),_vm._v(" "),_vm._l((_vm.triggerList),function(row){return _c('tr',{attrs:{"data-id":row.trigger_id}},[_c('td',[_vm._v(_vm._s(row.trigger_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('td',[(row.data_type == 1)?_c('a',{attrs:{"data-toggle":"modal","data-target":".js-show-date-range-modal","href":"#"},on:{"click":function($event){return _vm.showByDataType(row)}}},[_vm._v("时间段")]):_vm._e(),_vm._v(" "),(row.data_type == 2)?_c('a',{attrs:{"data-toggle":"modal","data-target":".js-show-prize-modal","href":"#"},on:{"click":function($event){return _vm.showByDataType(row)}}},[_vm._v("奖品池数量")]):_vm._e(),_vm._v(" "),(row.data_type == 3)?_c('span',[_vm._v("用户是否充值")]):_vm._e()]),_vm._v(" "),_c('td',[(row.game_room_id == 0)?_c('span',[_vm._v("所有房间")]):_vm._e(),_vm._v(" "),(row.game_room_id != 0)?_c('span',[_vm._v(_vm._s(row.game_room_name))]):_vm._e()]),_vm._v(" "),_c('td',[(row.prob_type == 1)?_c('span',[_vm._v("概率上调")]):_vm._e(),_vm._v(" "),(row.prob_type == 2)?_c('span',[_vm._v("概率下调")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(row.change_rate)+"%")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[(row.status == 1)?_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button"}},[_vm._v("启用")]):_vm._e(),_vm._v(" "),(row.status == 0)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"}},[_vm._v("禁用")]):_vm._e(),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[(row.status == 0)?_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeStatus(row, 1)}}},[_vm._v("启用")])]):_vm._e(),_vm._v(" "),(row.status == 1)?_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeStatus(row, 0)}}},[_vm._v("禁用")])]):_vm._e()])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.created_at))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","data-toggle":"modal","data-target":".js-edit-trigger-modal"},on:{"click":function($event){return _vm.editTrigger(row)}}},[_vm._v("编辑")])])])])}),_vm._v(" "),_vm._m(3)],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer clearfix"},[_c('pagination',{attrs:{"page":_vm.currentPage,"pages":_vm.lastPage,"width":10,"pageFn":_vm.pageFn},on:{"change":_vm.pageChanged}}),_vm._v(" "),_c('div',{staticClass:"box-tools box-footer-appoint"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appointPage),expression:"appointPage"}],staticClass:"form-control pull-right",attrs:{"type":"number","placeholder":"指定页"},domProps:{"value":(_vm.appointPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appointPage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.pageJumped()}}},[_vm._v("跳转")])])])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-add-trigger-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.name),expression:"newOne.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.newOne.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newOne, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("数据类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.data_type),expression:"newOne.data_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newOne, "data_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.newOne.data_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("时间段")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("奖品池数量")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("用户是否充值")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整概率类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.prob_type),expression:"newOne.prob_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newOne, "prob_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.newOne.prob_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("概率上调")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("概率下调")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整概率数值：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.change_rate),expression:"newOne.change_rate"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"单位：%"},domProps:{"value":(_vm.newOne.change_rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newOne, "change_rate", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.newOne.data_type == '1'),expression:"newOne.data_type == '1'"}]},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("绑定房间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.game_room_id),expression:"newOne.game_room_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newOne, "game_room_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.newOne.game_room_id)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("所有房间")]),_vm._v(" "),_vm._l((_vm.gameRoomList),function(room){return _c('option',{domProps:{"value":room.game_room_id}},[_vm._v(_vm._s(room.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("有效时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.dateOptions},model:{value:(_vm.newDate),callback:function ($$v) {_vm.newDate=$$v},expression:"newDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("重复类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.date_scope.repeat_type),expression:"newOne.date_scope.repeat_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newOne.date_scope, "repeat_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.newOne.date_scope.repeat_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("不重复")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("每天重复")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("每周重复")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("每月重复")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("每年重复")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.newOne.data_type == '2'),expression:"newOne.data_type == '2'"}]},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("剩余奖品池数量：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.trigger_term.opt),expression:"newOne.trigger_term.opt"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newOne.trigger_term, "opt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.newOne.trigger_term.opt)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("等于")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("大于")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("小于")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("大于等于")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("小于等于")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("不等于")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("变更")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newOne.trigger_term.data_value),expression:"newOne.trigger_term.data_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"请填写剩余奖品池数量"},domProps:{"value":(_vm.newOne.trigger_term.data_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newOne.trigger_term, "data_value", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveTrigger(_vm.newOne, 'add')}}},[_vm._v("保存")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-show-date-range-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("触发器具体信息 - "+_vm._s(_vm.trigger.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.trigger.date_scope)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("开始时间：")]),_vm._v(" "),_c('p',{staticClass:"col-xs-9 form-control-static"},[_vm._v("\n              "+_vm._s(_vm.trigger.date_scope.start_time)+" -- \n              "),(_vm.trigger.date_scope.start_week == 0)?_c('span',[_vm._v("周日")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.start_week == 1)?_c('span',[_vm._v("周一")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.start_week == 2)?_c('span',[_vm._v("周二")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.start_week == 3)?_c('span',[_vm._v("周三")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.start_week == 4)?_c('span',[_vm._v("周四")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.start_week == 5)?_c('span',[_vm._v("周五")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.start_week == 6)?_c('span',[_vm._v("周六")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("结束时间：")]),_vm._v(" "),_c('p',{staticClass:"col-xs-9 form-control-static"},[_vm._v("\n              "+_vm._s(_vm.trigger.date_scope.end_time)+" -- \n              "),(_vm.trigger.date_scope.end_week == 0)?_c('span',[_vm._v("周日")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.end_week == 1)?_c('span',[_vm._v("周一")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.end_week == 2)?_c('span',[_vm._v("周二")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.end_week == 3)?_c('span',[_vm._v("周三")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.end_week == 4)?_c('span',[_vm._v("周四")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.end_week == 5)?_c('span',[_vm._v("周五")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.end_week == 6)?_c('span',[_vm._v("周六")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("重复类型：")]),_vm._v(" "),_c('p',{staticClass:"col-xs-9 form-control-static"},[(_vm.trigger.date_scope.repeat_type == 1)?_c('span',[_vm._v("不重复")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.repeat_type == 2)?_c('span',[_vm._v("每天重复")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.repeat_type == 3)?_c('span',[_vm._v("每周重复")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.repeat_type == 4)?_c('span',[_vm._v("每月重复")]):_vm._e(),_vm._v(" "),(_vm.trigger.date_scope.repeat_type == 5)?_c('span',[_vm._v("每年重复")]):_vm._e()])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-show-prize-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("触发器具体信息 - "+_vm._s(_vm.trigger.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.trigger.trigger_term)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("触发条件：")]),_vm._v(" "),_c('p',{staticClass:"col-xs-9 form-control-static"},[_c('span',[_vm._v("剩余奖品池数量 ")]),_vm._v(" "),(_vm.trigger.trigger_term.opt == 0)?_c('span',[_vm._v("等于")]):_vm._e(),_vm._v(" "),(_vm.trigger.trigger_term.opt == 1)?_c('span',[_vm._v("大于")]):_vm._e(),_vm._v(" "),(_vm.trigger.trigger_term.opt == 2)?_c('span',[_vm._v("小于")]):_vm._e(),_vm._v(" "),(_vm.trigger.trigger_term.opt == 3)?_c('span',[_vm._v("大于等于")]):_vm._e(),_vm._v(" "),(_vm.trigger.trigger_term.opt == 4)?_c('span',[_vm._v("小于等于")]):_vm._e(),_vm._v(" "),(_vm.trigger.trigger_term.opt == 5)?_c('span',[_vm._v("不等于")]):_vm._e(),_vm._v(" "),(_vm.trigger.trigger_term.opt == 6)?_c('span',[_vm._v("变更")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.trigger.trigger_term.data_value))])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-edit-trigger-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("编辑触发规则 - "+_vm._s(_vm.trigger.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.name),expression:"trigger.name"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.trigger.data_type == '3'},domProps:{"value":(_vm.trigger.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.trigger, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("数据类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.data_type),expression:"trigger.data_type"}],staticClass:"form-control",attrs:{"disabled":_vm.trigger.data_type == '3'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.trigger, "data_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.trigger.data_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("时间段")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("奖品池数量")]),_vm._v(" "),_c('option',{attrs:{"value":"3","disabled":""}},[_vm._v("用户是否充值")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整概率类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.prob_type),expression:"trigger.prob_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.trigger, "prob_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.trigger.prob_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("概率上调")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("概率下调")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("调整概率数值：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.change_rate),expression:"trigger.change_rate"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"单位：%"},domProps:{"value":(_vm.trigger.change_rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.trigger, "change_rate", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.trigger.data_type == '1'),expression:"trigger.data_type == '1'"}]},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("绑定房间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.game_room_id),expression:"trigger.game_room_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.trigger, "game_room_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.trigger.game_room_id)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("所有房间")]),_vm._v(" "),_vm._l((_vm.gameRoomList),function(room){return _c('option',{domProps:{"value":room.game_room_id}},[_vm._v(_vm._s(room.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("有效时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.dateOptions},model:{value:(_vm.editDate),callback:function ($$v) {_vm.editDate=$$v},expression:"editDate"}})],1)]),_vm._v(" "),(_vm.trigger.date_scope)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("重复类型：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.date_scope.repeat_type),expression:"trigger.date_scope.repeat_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.trigger.date_scope, "repeat_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.trigger.date_scope.repeat_type)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("不重复")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("每天重复")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("每周重复")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("每月重复")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("每年重复")])])])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.trigger.data_type == '2'),expression:"trigger.data_type == '2'"}]},[(_vm.trigger.trigger_term)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("剩余奖品池数量：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.trigger_term.opt),expression:"trigger.trigger_term.opt"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.trigger.trigger_term, "opt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.trigger.trigger_term.opt)?_c('option',{attrs:{"value":""}},[_vm._v("请选择")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("等于")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("大于")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("小于")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("大于等于")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("小于等于")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("不等于")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("变更")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.trigger_term.data_value),expression:"trigger.trigger_term.data_value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"请填写剩余奖品池数量"},domProps:{"value":(_vm.trigger.trigger_term.data_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.trigger.trigger_term, "data_value", $event.target.value)}}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveTrigger(_vm.trigger, 'edit')}}},[_vm._v("保存")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-edit-global-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("奖品池实际剩余数量：")]),_vm._v(" "),_c('p',{staticClass:"col-xs-8 form-control-static"},[_vm._v(_vm._s(_vm.trigger.dynamic_prize_amount))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("全局实际成功率：")]),_vm._v(" "),_c('p',{staticClass:"col-xs-8 form-control-static"},[_vm._v(_vm._s(_vm.trigger.actual_success_rate)+"%")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("初始奖品池数量：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.base_prize_amount),expression:"trigger.base_prize_amount"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.trigger.base_prize_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.trigger, "base_prize_amount", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("奖品池期望中奖率：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.expected_gold_rate),expression:"trigger.expected_gold_rate"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"单位：%"},domProps:{"value":(_vm.trigger.expected_gold_rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.trigger, "expected_gold_rate", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-4 control-label"},[_vm._v("全局初始成功率：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trigger.initial_success_rate),expression:"trigger.initial_success_rate"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"单位：%"},domProps:{"value":(_vm.trigger.initial_success_rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.trigger, "initial_success_rate", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("%")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-4 col-xs-8"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveGlobalInfo(_vm.trigger)}}},[_vm._v("保存")])])])])])])])])],1)}
var PageRoomTrigger_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-toggle":"modal","data-target":".js-add-trigger-modal"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v("新增触发规则")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("名称")]),_vm._v(" "),_c('th',[_vm._v("数据类型")]),_vm._v(" "),_c('th',[_vm._v("绑定房间")]),_vm._v(" "),_c('th',[_vm._v("调整概率")]),_vm._v(" "),_c('th',[_vm._v("状态")]),_vm._v(" "),_c('th',[_vm._v("创建时间")]),_vm._v(" "),_c('th',[_vm._v("操作")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"10"}},[_c('h3',[_vm._v(" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("新增触发规则")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("触发器全局设置")])])}]
var PageRoomTrigger_esExports = { render: PageRoomTrigger_render, staticRenderFns: PageRoomTrigger_staticRenderFns }
/* harmony default export */ var pages_PageRoomTrigger = (PageRoomTrigger_esExports);
// CONCATENATED MODULE: ./src/pages/PageRoomTrigger.vue
function PageRoomTrigger_injectStyle (ssrContext) {
  __webpack_require__("dwQ9")
}
var PageRoomTrigger_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageRoomTrigger___vue_template_functional__ = false
/* styles */
var PageRoomTrigger___vue_styles__ = PageRoomTrigger_injectStyle
/* scopeId */
var PageRoomTrigger___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageRoomTrigger___vue_module_identifier__ = null
var PageRoomTrigger_Component = PageRoomTrigger_normalizeComponent(
  PageRoomTrigger,
  pages_PageRoomTrigger,
  PageRoomTrigger___vue_template_functional__,
  PageRoomTrigger___vue_styles__,
  PageRoomTrigger___vue_scopeId__,
  PageRoomTrigger___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageRoomTrigger = (PageRoomTrigger_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageRoomSession.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var PageRoomSession_Pagination = __webpack_require__("u5iF").default

/* harmony default export */ var PageRoomSession = ({
  components: {
    ContentHeader: src_components_ContentHeader,
    Pagination: PageRoomSession_Pagination,
    DateRangePicker: src_components_DateRangePicker
  },
  data: function data () {
    return {
      searchRoomName: '',
      searchSessionID: '',
      searchStatus: '',
      searchPayStatus: '',
      searchExchangeStatus: '',
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      canSaveSessionGold: false,
      canRefundOrder: false,
      gameSessionList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    this.getGameSession()
  },
  computed: {
  },
  methods: {
    // 获取游戏记录
    getGameSession: function (page) {
      var this$1 = this;
      if ( page === void 0 ) page = 1;

      var params = {
        page: page,
        room_name: this.searchRoomName,
        game_session_id: this.searchSessionID,
        status: this.searchStatus,
        pay_status: this.searchPayStatus,
        exchange_status: this.searchExchangeStatus,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText
      }
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/game/session/info'), {params: params}).then(function (response) {
        var resp = response.data
        this$1.gameSessionList = resp.gameSessionList.data;
        this$1.totalItems = resp.gameSessionList.total;
        this$1.currentPage = resp.gameSessionList.current_page;
        this$1.perPage = resp.gameSessionList.per_page;
        this$1.lastPage = resp.gameSessionList.last_page;
      });
    },
    // 分页跳转
    pageChanged: function (page) {
      if ( page === void 0 ) page = 1;

      this.getGameSession(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getGameSession(appointPage);
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0266b18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageRoomSession.vue
var PageRoomSession_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-solid"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("房间名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRoomName),expression:"searchRoomName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"模糊搜索"},domProps:{"value":(_vm.searchRoomName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchRoomName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("游戏ID：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchSessionID),expression:"searchSessionID"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.searchSessionID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchSessionID=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("游戏状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchStatus),expression:"searchStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("取消")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("游戏中")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("失败")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("成功")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("支付状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchPayStatus),expression:"searchPayStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchPayStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("未支付")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("已支付")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("付款中")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("已退款")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("兑换状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchExchangeStatus),expression:"searchExchangeStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchExchangeStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("未兑换")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("已兑换")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label",attrs:{"for":""}},[_vm._v("游戏时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.dateOptions},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getGameSession()}}},[_c('i',{staticClass:"fa fa-fw fa-search"}),_vm._v(" "),_c('span',[_vm._v("搜索")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("总体("+_vm._s(_vm.totalItems)+")")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.gameSessionList),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.game_session_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.room_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.game_user_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.binding_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.nickname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.goods_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.coins))]),_vm._v(" "),_c('td',[(row.status == 0)?_c('span',{staticClass:"label label-warning"},[_vm._v("取消")]):_vm._e(),_vm._v(" "),(row.status == 1)?_c('span',{staticClass:"label label-primary"},[_vm._v("游戏中")]):_vm._e(),_vm._v(" "),(row.status == 2)?_c('span',{staticClass:"label label-danger"},[_vm._v("失败")]):_vm._e(),_vm._v(" "),(row.status == 3)?_c('span',{staticClass:"label label-success"},[_vm._v("成功")]):_vm._e()]),_vm._v(" "),_c('td',[(row.pay_status == 0)?_c('span',{staticClass:"label label-warning"},[_vm._v("未支付")]):_vm._e(),_vm._v(" "),(row.pay_status == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("已支付")]):_vm._e(),_vm._v(" "),(row.pay_status == 2)?_c('span',{staticClass:"label label-danger"},[_vm._v("已退款")]):_vm._e(),_vm._v(" "),(row.pay_status == 3)?_c('span',{staticClass:"label label-primary"},[_vm._v("付款中")]):_vm._e()]),_vm._v(" "),_c('td',[(row.exchange_status == 0)?_c('span',{staticClass:"label label-warning"},[_vm._v("未兑换")]):_vm._e(),_vm._v(" "),(row.exchange_status == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("已兑换")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.created_at))])])}),_vm._v(" "),_vm._m(1)],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer clearfix"},[_c('pagination',{attrs:{"page":_vm.currentPage,"pages":_vm.lastPage,"width":10,"pageFn":_vm.pageFn},on:{"change":_vm.pageChanged}}),_vm._v(" "),_c('div',{staticClass:"box-tools box-footer-appoint"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appointPage),expression:"appointPage"}],staticClass:"form-control pull-right",attrs:{"type":"number","placeholder":"指定页"},domProps:{"value":(_vm.appointPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appointPage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.pageJumped()}}},[_vm._v("跳转")])])])])],1)])])])])],1)}
var PageRoomSession_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("房间")]),_vm._v(" "),_c('th',[_vm._v("玩家ID")]),_vm._v(" "),_c('th',[_vm._v("玩家标识")]),_vm._v(" "),_c('th',[_vm._v("玩家昵称")]),_vm._v(" "),_c('th',[_vm._v("商品名称")]),_vm._v(" "),_c('th',[_vm._v("花费游戏币")]),_vm._v(" "),_c('th',[_vm._v("游戏状态")]),_vm._v(" "),_c('th',[_vm._v("支付状态")]),_vm._v(" "),_c('th',[_vm._v("兑换状态")]),_vm._v(" "),_c('th',[_vm._v("游戏时间")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"10"}},[_c('h3',[_vm._v(" ")])])])}]
var PageRoomSession_esExports = { render: PageRoomSession_render, staticRenderFns: PageRoomSession_staticRenderFns }
/* harmony default export */ var pages_PageRoomSession = (PageRoomSession_esExports);
// CONCATENATED MODULE: ./src/pages/PageRoomSession.vue
function PageRoomSession_injectStyle (ssrContext) {
  __webpack_require__("ffrA")
}
var PageRoomSession_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageRoomSession___vue_template_functional__ = false
/* styles */
var PageRoomSession___vue_styles__ = PageRoomSession_injectStyle
/* scopeId */
var PageRoomSession___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageRoomSession___vue_module_identifier__ = null
var PageRoomSession_Component = PageRoomSession_normalizeComponent(
  PageRoomSession,
  pages_PageRoomSession,
  PageRoomSession___vue_template_functional__,
  PageRoomSession___vue_styles__,
  PageRoomSession___vue_scopeId__,
  PageRoomSession___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageRoomSession = (PageRoomSession_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageShopOrderList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var PageShopOrderList_Pagination = __webpack_require__("u5iF").default

/* harmony default export */ var PageShopOrderList = ({
  components: {
    ContentHeader: src_components_ContentHeader,
    Pagination: PageShopOrderList_Pagination,
    DateRangePicker: src_components_DateRangePicker
  },
  data: function data () {
    return {
      searchTransactionId: '',
      searchPayStatus: '',
      searchOrderStatus: '',
      searchShippingStatus: '',
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      singleDateOptions: JSON.parse(JSON.stringify(this.dateTimePickerOptions)),
      deo: {},
      deoDate: {startDate: '', startDateText: ''},
      searchSum: 2,
      orderList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0,
      shipList: []
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    // 获取物流公司列表
    var $this = this
    vue_esm["a" /* default */].http.get(this.serviceUrl('api/shipping/list'), {params: {search_type: 'all'}}).then(function (resp) {
      $this.shipList = resp.data.shipList;
    })
    // 检测是否有指定参数
    var transactionID = this.$route.params.transaction_id;
    if (transactionID) {
      this.searchTransactionId = transactionID;
      this.getOrderList(1);
    } else {
      this.getOrderList()
    }
  },
  computed: {
  },
  methods: {
    // 获取订单列表
    getOrderList: function (page) {
      if ( page === void 0 ) page = 1;

      var $this = this
      var params = {
        page: page,
        transaction_id: this.searchTransactionId,
        pay_status: this.searchPayStatus,
        order_status: this.searchOrderStatus,
        shipping_status: this.searchShippingStatus,
        pay_type: this.searchPayType,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText,
        sum: this.searchSum
      }
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/shop/order/list'), {params: params}).then(function (response) {
        var resp = response.data
        $this.orderList = resp.orderList.data;
        $this.totalItems = resp.orderList.total;
        $this.currentPage = resp.orderList.current_page;
        $this.perPage = resp.orderList.per_page;
        $this.lastPage = resp.orderList.last_page;
        $this.totalCost = resp.total_cost;
        $this.totalFee = resp.total_fee;
        $this.totalOriginPrice = resp.total_origin_price;
      })
    },
    // 分页跳转
    pageChanged: function (page) {
      if ( page === void 0 ) page = 1;

      this.getOrderList(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getOrderList(appointPage);
    },
    showDeliveryModel: function (row) {
      var self = this;
      self.deo = row;
      if (row.order_address && row.order_address.delivery_date) {
        if (self.deoDate.startDate) {
          self.deoDate = {startDate: row.order_address.delivery_date, startDateText: row.order_address.delivery_date};
        } else {
          setTimeout(function () {
            self.deoDate = {startDate: row.order_address.delivery_date, startDateText: row.order_address.delivery_date};
          }, 1000);
        }
      }
    },
    saveOrderAddress: function (addr) {
      var self = this;
      addr.delivery_date = this.deoDate.startDateText;
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/shop/order/address/' + addr.shop_order_id),
        data: addr
      }).then(function (response) {
        var resp = response.data
        if (resp.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.errmsg, 2);
        }
      });
    },
    deoFeeOnChange: function (addr) {
      if (!addr.shipping_fee) {
        addr.shipping_fee = 0;
      }
    },
    saveOrder: function (order) {
      var self = this;
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/shop/order/' + order.shop_order_id),
        data: order
      }).then(function (response) {
        var resp = response.data
        if (resp.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.errmsg, 2);
        }
      });
    },
    changeOrderStatus: function (order, status) {
      order.order_status = status;
      this.saveOrder(order);
    },
    changeOrderShippingStatus: function (order, status) {
      order.shipping_status = status;
      this.saveOrder(order);
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9108ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageShopOrderList.vue
var PageShopOrderList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-solid"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("订单号：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTransactionId),expression:"searchTransactionId"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.searchTransactionId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTransactionId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("支付状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchPayStatus),expression:"searchPayStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchPayStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("未支付")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("付款中")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("已支付")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("已退款")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("订单状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchOrderStatus),expression:"searchOrderStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchOrderStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("取消")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("待处理")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("已处理")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("申请退货")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("物流状态：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchShippingStatus),expression:"searchShippingStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.searchShippingStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("全部")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("未发货")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("已发货")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("已退货")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("已收货")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label",attrs:{"for":""}},[_vm._v("创建时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.dateOptions},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getOrderList()}}},[_c('i',{staticClass:"fa fa-fw fa-search"}),_vm._v(" "),_c('span',[_vm._v("搜索")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("总体("+_vm._s(_vm.totalItems)+")")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.orderList),function(row){return _c('tr',{attrs:{"data-id":row.shop_order_id}},[_c('td',[_vm._v(_vm._s(row.shop_order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.transaction_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.game_user_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.binding_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.nickname))]),_vm._v(" "),_c('td',[(row.pay_status == 0)?_c('span',{staticClass:"label label-warning"},[_vm._v("未支付")]):_vm._e(),_vm._v(" "),(row.pay_status == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("已支付")]):_vm._e(),_vm._v(" "),(row.pay_status == 2)?_c('span',{staticClass:"label label-danger"},[_vm._v("已退款")]):_vm._e(),_vm._v(" "),(row.pay_status == 3)?_c('span',{staticClass:"label label-primary"},[_vm._v("付款中")]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[(row.order_status == 0)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"}},[_vm._v("取消")]):_vm._e(),_vm._v(" "),(row.order_status == 1)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"}},[_vm._v("待处理")]):_vm._e(),_vm._v(" "),(row.order_status == 2)?_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button"}},[_vm._v("已处理")]):_vm._e(),_vm._v(" "),(row.order_status == 3)?_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"}},[_vm._v("申请退款")]):_vm._e(),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderStatus(row, 0)}}},[_vm._v("取消")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderStatus(row, 1)}}},[_vm._v("待处理")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderStatus(row, 2)}}},[_vm._v("已处理")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderStatus(row, 3)}}},[_vm._v("申请退款")])])])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[(row.shipping_status == 0)?_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"}},[_vm._v("未发货")]):_vm._e(),_vm._v(" "),(row.shipping_status == 1)?_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button"}},[_vm._v("已发货")]):_vm._e(),_vm._v(" "),(row.shipping_status == 2)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"}},[_vm._v("已退货")]):_vm._e(),_vm._v(" "),(row.shipping_status == 3)?_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button"}},[_vm._v("已收货")]):_vm._e(),_vm._v(" "),_vm._m(2,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderShippingStatus(row, 0)}}},[_vm._v("未发货")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderShippingStatus(row, 1)}}},[_vm._v("已发货")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderShippingStatus(row, 2)}}},[_vm._v("已退货")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changeOrderShippingStatus(row, 3)}}},[_vm._v("已收货")])])])])]),_vm._v(" "),(row.order_address)?[_c('td',[_vm._v(_vm._s(row.order_address.consignee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.order_address.contact))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.order_address.address_detail))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.order_address.remark))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.created_at))])]:[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')],_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":".js-delivery-modal"},on:{"click":function($event){return _vm.showDeliveryModel(row)}}},[_vm._v("发货")])])],2)}),_vm._v(" "),_c('tr',{staticClass:"tr-space"})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer clearfix"},[_c('pagination',{attrs:{"page":_vm.currentPage,"pages":_vm.lastPage,"width":10,"pageFn":_vm.pageFn},on:{"change":_vm.pageChanged}}),_vm._v(" "),_c('div',{staticClass:"box-tools box-footer-appoint"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appointPage),expression:"appointPage"}],staticClass:"form-control pull-right",attrs:{"type":"number","placeholder":"指定页"},domProps:{"value":(_vm.appointPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appointPage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.pageJumped()}}},[_vm._v("跳转")])])])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-delivery-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[(_vm.deo.transaction_id)?_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("发货信息 - "+_vm._s(_vm.deo.transaction_id))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("姓名：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v("\n                "+_vm._s(_vm.deo.order_address.consignee)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("联系方式：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v("\n                "+_vm._s(_vm.deo.order_address.contact)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v("\n                "+_vm._s(_vm.deo.order_address.province_text)+" "+_vm._s(_vm.deo.order_address.city_text)+" "+_vm._s(_vm.deo.order_address.county_text)+" "+_vm._s(_vm.deo.order_address.address_detail)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("邮政编码：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v("\n                "+_vm._s(_vm.deo.order_address.zipcode)+"\n                ")])])]),_vm._v(" "),(_vm.deo.order_address)?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("快递公司：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.deo.order_address.shipping_id),expression:"deo.order_address.shipping_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.deo.order_address, "shipping_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("请选择")]),_vm._v(" "),_vm._l((_vm.shipList),function(row){return _c('option',{domProps:{"value":row.shipping_id}},[_vm._v(_vm._s(row.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("快递单号：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deo.order_address.shipping_order_no),expression:"deo.order_address.shipping_order_no"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.deo.order_address.shipping_order_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deo.order_address, "shipping_order_no", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("快递费用：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.deo.order_address.shipping_fee),expression:"deo.order_address.shipping_fee",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.deo.order_address.shipping_fee)},on:{"change":function($event){return _vm.deoFeeOnChange(_vm.deo.order_address)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deo.order_address, "shipping_fee", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("快递备注：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deo.order_address.shipping_remark),expression:"deo.order_address.shipping_remark"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.deo.order_address.shipping_remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deo.order_address, "shipping_remark", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("发货时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.singleDateOptions},model:{value:(_vm.deoDate),callback:function ($$v) {_vm.deoDate=$$v},expression:"deoDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveOrderAddress(_vm.deo.order_address)}}},[_vm._v("保存")])])])])])])])]):_vm._e()])],1)}
var PageShopOrderList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("订单号")]),_vm._v(" "),_c('th',[_vm._v("玩家ID")]),_vm._v(" "),_c('th',[_vm._v("玩家标识")]),_vm._v(" "),_c('th',[_vm._v("玩家昵称")]),_vm._v(" "),_c('th',[_vm._v("支付状态")]),_vm._v(" "),_c('th',[_vm._v("订单状态")]),_vm._v(" "),_c('th',[_vm._v("物流状态")]),_vm._v(" "),_c('th',[_vm._v("收货人")]),_vm._v(" "),_c('th',[_vm._v("联系方式")]),_vm._v(" "),_c('th',[_vm._v("收货地址")]),_vm._v(" "),_c('th',[_vm._v("备注")]),_vm._v(" "),_c('th',[_vm._v("创建时间")]),_vm._v(" "),_c('th',[_vm._v("操作")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var PageShopOrderList_esExports = { render: PageShopOrderList_render, staticRenderFns: PageShopOrderList_staticRenderFns }
/* harmony default export */ var pages_PageShopOrderList = (PageShopOrderList_esExports);
// CONCATENATED MODULE: ./src/pages/PageShopOrderList.vue
function PageShopOrderList_injectStyle (ssrContext) {
  __webpack_require__("VjOs")
}
var PageShopOrderList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageShopOrderList___vue_template_functional__ = false
/* styles */
var PageShopOrderList___vue_styles__ = PageShopOrderList_injectStyle
/* scopeId */
var PageShopOrderList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageShopOrderList___vue_module_identifier__ = null
var PageShopOrderList_Component = PageShopOrderList_normalizeComponent(
  PageShopOrderList,
  pages_PageShopOrderList,
  PageShopOrderList___vue_template_functional__,
  PageShopOrderList___vue_styles__,
  PageShopOrderList___vue_scopeId__,
  PageShopOrderList___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageShopOrderList = (PageShopOrderList_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SortOrderTableTh.vue
//
//
//
//

var allComponents = [] // 保存所有组件

/* harmony default export */ var SortOrderTableTh = ({
  name: 'sort-order-table-th',
  components: {
  },
  props: {
    column: {
      required: true
    }
  },
  data: function data () {
    return {
      sortType: '',
      params: {}
    }
  },
  created: function created () {
    allComponents.push(this)
  },
  mounted: function mounted () {
  },
  /**
   * Free up memory
   */
  beforeDestroy: function beforeDestroy () {
    var this$1 = this;

    this.params = null
    for (var i = 0; i < allComponents.length; i++) {
      if (allComponents[i] === this$1) {
        allComponents.splice(i, 1)
        break
      }
    }
  },
  watch: {
  },
  computed: {
    classStr: function () {
      return this.sortType === '' ? 'sorting' : (this.sortType === 'ASC' ? 'sorting_asc' : 'sorting_desc')
    }
  },
  methods: {
    onSortOrder: function onSortOrder () {
      var this$1 = this;
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      for (var i = 0; i < allComponents.length; i++) {
        // 清楚所有组件的样式
        if (allComponents[i] === this$1) {
          continue
        }
        allComponents[i].sortType = ''
      }
      this.sortType = this.sortType === 'DESC' ? 'ASC' : 'DESC'
      this.params = {sortType: this.sortType, sortColumn: this.column}

      var ref = this;
      ref.$emit.apply(ref, [ 'trigger' ].concat( [this.params ].concat( args) ));
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e6e58c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SortOrderTableTh.vue
var SortOrderTableTh_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"sort-th",class:_vm.classStr,on:{"click":_vm.onSortOrder}},[_vm._t("default")],2)}
var SortOrderTableTh_staticRenderFns = []
var SortOrderTableTh_esExports = { render: SortOrderTableTh_render, staticRenderFns: SortOrderTableTh_staticRenderFns }
/* harmony default export */ var components_SortOrderTableTh = (SortOrderTableTh_esExports);
// CONCATENATED MODULE: ./src/components/SortOrderTableTh.vue
function SortOrderTableTh_injectStyle (ssrContext) {
  __webpack_require__("Axpc")
}
var SortOrderTableTh_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SortOrderTableTh___vue_template_functional__ = false
/* styles */
var SortOrderTableTh___vue_styles__ = SortOrderTableTh_injectStyle
/* scopeId */
var SortOrderTableTh___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SortOrderTableTh___vue_module_identifier__ = null
var SortOrderTableTh_Component = SortOrderTableTh_normalizeComponent(
  SortOrderTableTh,
  components_SortOrderTableTh,
  SortOrderTableTh___vue_template_functional__,
  SortOrderTableTh___vue_styles__,
  SortOrderTableTh___vue_scopeId__,
  SortOrderTableTh___vue_module_identifier__
)

/* harmony default export */ var src_components_SortOrderTableTh = (SortOrderTableTh_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageGameUserList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PageGameUserList_Pagination = __webpack_require__("u5iF").default

/* harmony default export */ var PageGameUserList = ({
  components: {
    ContentHeader: src_components_ContentHeader,
    Pagination: PageGameUserList_Pagination,
    DateRangePicker: src_components_DateRangePicker,
    SortOrderTableTh: src_components_SortOrderTableTh
  },
  data: function data () {
    return {
      sortParams: {},
      searchBindingId: '',
      newBindingId: '',
      addCoinAmount: 0,
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      playerList: [],
      user: {},
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    this.getPlayerList();
  },
  computed: {
  },
  methods: {
    // 获取用户列表
    getPlayerList: function (page, sortParams) {
      if ( page === void 0 ) page = 1;

      var $this = this
      if (sortParams === undefined) {
        sortParams = this.sortParams;
      }
      var params = {
        page: page,
        binding_id: this.searchBindingId,
        sort_column: sortParams.sortColumn,
        sort_type: sortParams.sortType,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText
      }
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/player/list'), {params: params}).then(function (response) {
        var resp = response.data
        $this.playerList = resp.playerList.data;
        $this.totalItems = resp.playerList.total;
        $this.currentPage = resp.playerList.current_page;
        $this.perPage = resp.playerList.per_page;
        $this.lastPage = resp.playerList.last_page;
      })
    },
    // 分页跳转
    pageChanged: function (page) {
      if ( page === void 0 ) page = 1;

      this.getPlayerList(page)
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getPlayerList(appointPage);
    },
    onSortOrder: function (params, event) {
      this.sortParams = params
      this.getPlayerList(1, params);
    },
    // 赋值
    assignInfo: function (row) {
      this.user = row;
    },
    // 新增玩家
    addPlayer: function () {
      var $this = this
      var bindingId = jquery_default.a.trim(this.newBindingId);
      if (!bindingId) {
        $this.alert('接入方唯一标识不能为空', 2);
        return false;
      }
      if (bindingId.length > 64) {
        $this.alert('接入方唯一标识长度不超过64个字节', 2);
        return false;
      }
      if (!confirm('确定新增？')) {
        return false;
      }
      var data = {
        binding_id: bindingId
      }
      vue_esm["a" /* default */].http({
        method: 'POST',
        url: this.serviceUrl('api/player/add'),
        data: data
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.getPlayerList(1);
          $this.newBindingId = '';
          jquery_default()('.js-add-player-modal').modal('hide');
          $this.alert('充值成功', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    },
    // 充值游戏币
    addCoins: function (row) {
      var $this = this
      if (this.addCoinAmount <= 0) {
        $this.alert('充值游戏币需大于0', 2);
        return false;
      }
      if (!confirm('确定为ID为' + row.game_user_id + '的玩家充值' + this.addCoinAmount + '个游戏币？')) {
        return false;
      }
      var data = {
        coins: this.addCoinAmount,
        user_id: row.game_user_id
      }
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/player/recharge/coins'),
        data: data
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.getPlayerList($this.currentPage);
          $this.addCoinAmount = 0;
          jquery_default()('.js-recharge-modal').modal('hide');
          $this.alert('充值成功', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    // 游戏币清零
    clearCoins: function (row) {
      var $this = this
      if (!confirm(("确定清零ID为" + (row.game_user_id) + "的玩家的游戏币？"))) {
        return false;
      }
      var data = {
        user_id: row.game_user_id
      }
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/player/clear/coins'),
        data: data
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.getPlayerList($this.currentPage);
          $this.alert('成功清零', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc0808ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageGameUserList.vue
var PageGameUserList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-solid"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("接入方唯一标识：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBindingId),expression:"searchBindingId"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"模糊搜索"},domProps:{"value":(_vm.searchBindingId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBindingId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label",attrs:{"for":""}},[_vm._v("创建时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.dateOptions},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getPlayerList()}}},[_c('i',{staticClass:"fa fa-fw fa-search"}),_vm._v(" "),_c('span',[_vm._v("搜索")])]),_vm._v(" "),_vm._m(0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("总体("+_vm._s(_vm.totalItems)+")")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive no-padding"},[_c('table',{staticClass:"table table-hover dataTable"},[_c('thead',[_c('tr',[_c('sort-order-table-th',{attrs:{"column":"game_user_id"},on:{"trigger":_vm.onSortOrder}},[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("接入方唯一标识")]),_vm._v(" "),_c('th',[_vm._v("昵称")]),_vm._v(" "),_c('sort-order-table-th',{attrs:{"column":"coins"},on:{"trigger":_vm.onSortOrder}},[_vm._v("游戏币")]),_vm._v(" "),_c('sort-order-table-th',{attrs:{"column":"created_at"},on:{"trigger":_vm.onSortOrder}},[_vm._v("创建时间")]),_vm._v(" "),_c('th',[_vm._v("操作")])],1)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.playerList),function(row){return _c('tr',{attrs:{"data-id":row.user_id}},[_c('td',[_vm._v(_vm._s(row.game_user_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.binding_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.nickname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.coins))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.created_at))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group"},[_vm._m(1,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('li',[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".js-recharge-modal"},on:{"click":function($event){return _vm.assignInfo(row)}}},[_vm._v("充值游戏币")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.clearCoins(row)}}},[_vm._v("清零游戏币")])])])])])])}),_vm._v(" "),_vm._m(2)],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer clearfix"},[_c('pagination',{attrs:{"page":_vm.currentPage,"pages":_vm.lastPage,"width":10,"pageFn":_vm.pageFn},on:{"change":_vm.pageChanged}}),_vm._v(" "),_c('div',{staticClass:"box-tools box-footer-appoint"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appointPage),expression:"appointPage"}],staticClass:"form-control pull-right",attrs:{"type":"number","placeholder":"指定页"},domProps:{"value":(_vm.appointPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appointPage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.pageJumped()}}},[_vm._v("跳转")])])])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-recharge-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("游戏币充值 - (ID:"+_vm._s(_vm.user.game_user_id)+")")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("游戏币个数：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.addCoinAmount),expression:"addCoinAmount"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.addCoinAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addCoinAmount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.addCoins(_vm.user)}}},[_vm._v("充值")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade js-add-player-modal",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"reply-detail-label"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"form-horizontal"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("接入方唯一标识：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBindingId),expression:"newBindingId"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"长度不超过 64 个字节"},domProps:{"value":(_vm.newBindingId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newBindingId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.addPlayer()}}},[_vm._v("提交")])])])])])])])])])],1)}
var PageGameUserList_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-toggle":"modal","data-target":".js-add-player-modal"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "),_c('span',[_vm._v("新增玩家")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',[_vm._v("操作 ")]),_vm._v(" "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('h3',[_vm._v(" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("新增玩家")])])}]
var PageGameUserList_esExports = { render: PageGameUserList_render, staticRenderFns: PageGameUserList_staticRenderFns }
/* harmony default export */ var pages_PageGameUserList = (PageGameUserList_esExports);
// CONCATENATED MODULE: ./src/pages/PageGameUserList.vue
function PageGameUserList_injectStyle (ssrContext) {
  __webpack_require__("aSNA")
}
var PageGameUserList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageGameUserList___vue_template_functional__ = false
/* styles */
var PageGameUserList___vue_styles__ = PageGameUserList_injectStyle
/* scopeId */
var PageGameUserList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageGameUserList___vue_module_identifier__ = null
var PageGameUserList_Component = PageGameUserList_normalizeComponent(
  PageGameUserList,
  pages_PageGameUserList,
  PageGameUserList___vue_template_functional__,
  PageGameUserList___vue_styles__,
  PageGameUserList___vue_scopeId__,
  PageGameUserList___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageGameUserList = (PageGameUserList_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageGameUserCoinJournal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PageGameUserCoinJournal_Pagination = __webpack_require__("u5iF").default

/* harmony default export */ var PageGameUserCoinJournal = ({
  components: {
    ContentHeader: src_components_ContentHeader,
    Pagination: PageGameUserCoinJournal_Pagination,
    DateRangePicker: src_components_DateRangePicker,
    SortOrderTableTh: src_components_SortOrderTableTh
  },
  data: function data () {
    return {
      bindingId: '',
      transactionId: '',
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      coinJournalList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    this.getCoinJournal();
  },
  computed: {
  },
  methods: {
    // 获取游戏记录
    getCoinJournal: function (page) {
      if ( page === void 0 ) page = 1;

      var $this = this
      var params = {
        page: page,
        transaction_id: this.transactionId,
        binding_id: this.bindingId,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText
      }
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/player/coin/journal'), {params: params}).then(function (response) {
        var resp = response.data
        $this.coinJournalList = resp.coinJournal.data;
        $this.totalItems = resp.coinJournal.total;
        $this.currentPage = resp.coinJournal.current_page;
        $this.perPage = resp.coinJournal.per_page;
        $this.lastPage = resp.coinJournal.last_page;
      })
    },
    // 分页跳转
    pageChanged: function (page) {
      this.currentPage = page
      this.getCoinJournal(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getCoinJournal(appointPage);
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6098ccf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageGameUserCoinJournal.vue
var PageGameUserCoinJournal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-solid"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("流水号：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactionId),expression:"transactionId"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.transactionId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.transactionId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("玩家标识：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bindingId),expression:"bindingId"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bindingId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bindingId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label",attrs:{"for":""}},[_vm._v("创建时间：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('date-range-picker',{staticClass:"form-control",attrs:{"options":_vm.dateOptions},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getCoinJournal()}}},[_c('i',{staticClass:"fa fa-fw fa-search"}),_vm._v(" "),_c('span',[_vm._v("搜索")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("总体("+_vm._s(_vm.totalItems)+")")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.coinJournalList),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.gucj_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.transaction_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.binding_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.change_no))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.coins))]),_vm._v(" "),_c('td',[(row.type == 1)?_c('span',{staticClass:"label label-success"},[_vm._v("充值")]):_vm._e(),_vm._v(" "),(row.type == 2)?_c('span',{staticClass:"label label-warning"},[_vm._v("冻结")]):_vm._e(),_vm._v(" "),(row.type == 3)?_c('span',{staticClass:"label label-primary"},[_vm._v("解冻")]):_vm._e(),_vm._v(" "),(row.type == 4)?_c('span',{staticClass:"label label-danger"},[_vm._v("扣除")]):_vm._e(),_vm._v(" "),(row.type == 5)?_c('span',{staticClass:"label label-info"},[_vm._v("退还")]):_vm._e()]),_vm._v(" "),_c('td',[(row.refunded_id > 0)?_c('span',[_vm._v(_vm._s(row.refunded_id))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.refunded_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.remark))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.created_at))])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer clearfix"},[_c('pagination',{attrs:{"page":_vm.currentPage,"pages":_vm.lastPage,"width":10,"pageFn":_vm.pageFn},on:{"change":_vm.pageChanged}}),_vm._v(" "),_c('div',{staticClass:"box-tools box-footer-appoint"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.appointPage),expression:"appointPage"}],staticClass:"form-control pull-right",attrs:{"type":"number","placeholder":"指定页"},domProps:{"value":(_vm.appointPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.appointPage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.pageJumped()}}},[_vm._v("跳转")])])])])],1)])])])])],1)}
var PageGameUserCoinJournal_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("流水号")]),_vm._v(" "),_c('th',[_vm._v("玩家标识")]),_vm._v(" "),_c('th',[_vm._v("变更游戏币数量")]),_vm._v(" "),_c('th',[_vm._v("变更后游戏币数量")]),_vm._v(" "),_c('th',[_vm._v("变更类型")]),_vm._v(" "),_c('th',[_vm._v("退还ID")]),_vm._v(" "),_c('th',[_vm._v("退还时间")]),_vm._v(" "),_c('th',[_vm._v("备注")]),_vm._v(" "),_c('th',[_vm._v("创建时间")])])}]
var PageGameUserCoinJournal_esExports = { render: PageGameUserCoinJournal_render, staticRenderFns: PageGameUserCoinJournal_staticRenderFns }
/* harmony default export */ var pages_PageGameUserCoinJournal = (PageGameUserCoinJournal_esExports);
// CONCATENATED MODULE: ./src/pages/PageGameUserCoinJournal.vue
function PageGameUserCoinJournal_injectStyle (ssrContext) {
  __webpack_require__("Wqre")
}
var PageGameUserCoinJournal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageGameUserCoinJournal___vue_template_functional__ = false
/* styles */
var PageGameUserCoinJournal___vue_styles__ = PageGameUserCoinJournal_injectStyle
/* scopeId */
var PageGameUserCoinJournal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageGameUserCoinJournal___vue_module_identifier__ = null
var PageGameUserCoinJournal_Component = PageGameUserCoinJournal_normalizeComponent(
  PageGameUserCoinJournal,
  pages_PageGameUserCoinJournal,
  PageGameUserCoinJournal___vue_template_functional__,
  PageGameUserCoinJournal___vue_styles__,
  PageGameUserCoinJournal___vue_scopeId__,
  PageGameUserCoinJournal___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageGameUserCoinJournal = (PageGameUserCoinJournal_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageUserPassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PageUserPassword = ({
  components: {
    ContentHeader: src_components_ContentHeader
  },
  data: function data () {
    return {
      password: '',
      newPassword: '',
      comfirmPassword: ''
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
  },
  computed: {
  },
  methods: {
    savePassword: function () {
      var $this = this
      if (!this.password) {
        $this.alert('旧密码不能为空', 2);
        return false;
      }
      if (!this.newPassword) {
        $this.alert('新密码不能为空', 2);
        return false;
      }
      if (!this.comfirmPassword) {
        $this.alert('请确认新密码', 2);
        return false;
      }
      var params = {
        password: this.password,
        new_password: this.newPassword,
        confirm_password: this.comfirmPassword
      }
      vue_esm["a" /* default */].http({
        method: 'PUT',
        url: this.serviceUrl('api/user/password'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $this.password = '';
          $this.newPassword = '';
          $this.comfirmPassword = '';
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea789b08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageUserPassword.vue
var PageUserPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("旧密码：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("新密码：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.newPassword),expression:"newPassword",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","required":""},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-2 control-label"},[_vm._v("确认密码：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.comfirmPassword),expression:"comfirmPassword",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","required":""},domProps:{"value":(_vm.comfirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comfirmPassword=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-2 col-xs-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.savePassword()}}},[_c('i',{staticClass:"fa fa-fw fa-telegram"}),_vm._v(" "),_c('span',[_vm._v("保存")])])])])])])])])])])],1)}
var PageUserPassword_staticRenderFns = []
var PageUserPassword_esExports = { render: PageUserPassword_render, staticRenderFns: PageUserPassword_staticRenderFns }
/* harmony default export */ var pages_PageUserPassword = (PageUserPassword_esExports);
// CONCATENATED MODULE: ./src/pages/PageUserPassword.vue
function PageUserPassword_injectStyle (ssrContext) {
  __webpack_require__("3EH2")
}
var PageUserPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageUserPassword___vue_template_functional__ = false
/* styles */
var PageUserPassword___vue_styles__ = PageUserPassword_injectStyle
/* scopeId */
var PageUserPassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageUserPassword___vue_module_identifier__ = null
var PageUserPassword_Component = PageUserPassword_normalizeComponent(
  PageUserPassword,
  pages_PageUserPassword,
  PageUserPassword___vue_template_functional__,
  PageUserPassword___vue_styles__,
  PageUserPassword___vue_scopeId__,
  PageUserPassword___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageUserPassword = (PageUserPassword_Component.exports);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageApplication.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PageApplication = ({
  components: {
    ContentHeader: src_components_ContentHeader
  },
  data: function data () {
    return {
      application: {}
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    this.getApplication()
  },
  computed: {
  },
  methods: {
    getApplication: function () {
      var $this = this
      vue_esm["a" /* default */].http.get(this.serviceUrl('api/application')).then(function (resp) {
        $this.application = resp.data.application;
      })
    },
    saveApp: function () {
      var self = this
      var params = self.application;
      vue_esm["a" /* default */].http({
        method: 'PATCH',
        url: self.serviceUrl('api/application'),
        data: params
      }).then(function (resp) {
        if (resp.data.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.data.errmsg, 2);
        }
      })
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f7877dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageApplication.vue
var PageApplication_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('content-header'),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("开放平台app_id：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.application.open_app_id))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("开放平台app_secret：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.application.open_app_secret))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.application.shop_name && _vm.application.shop_status == 1),expression:"application.shop_name && application.shop_status == 1"}],staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("店铺名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.application.shop_name))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("腾讯云互动直播appid：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.application.sdk_appid))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("腾讯云应用名称：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.application.sdk_appid))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("腾讯云互动直播账号体系：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.application.account_type))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("接口IP白名单：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.application.ip_whitelist),expression:"application.ip_whitelist",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"row":"5","placeholder":"空则不限制，多个IP用\"|\"分割"},domProps:{"value":(_vm.application.ip_whitelist)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.application, "ip_whitelist", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("服务端回调地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.application.callback_url),expression:"application.callback_url",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.application.callback_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.application, "callback_url", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),(_vm.application.device_openapi == 1)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("盒子通信 Websocket 地址：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.application.device_ws_url),expression:"application.device_ws_url",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.application.device_ws_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.application, "device_ws_url", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-xs-offset-3 col-xs-9"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveApp()}}},[_c('span',[_vm._v("保存")])])])])])])])])])])],1)}
var PageApplication_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-xs-3 control-label"},[_vm._v("API接口文档：")]),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('p',{staticClass:"form-control-static"},[_c('a',{attrs:{"href":"http://open.doc.wowgotcha.com","target":"_blank"}},[_vm._v("传送门")])])])])}]
var PageApplication_esExports = { render: PageApplication_render, staticRenderFns: PageApplication_staticRenderFns }
/* harmony default export */ var pages_PageApplication = (PageApplication_esExports);
// CONCATENATED MODULE: ./src/pages/PageApplication.vue
function PageApplication_injectStyle (ssrContext) {
  __webpack_require__("+5KF")
}
var PageApplication_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageApplication___vue_template_functional__ = false
/* styles */
var PageApplication___vue_styles__ = PageApplication_injectStyle
/* scopeId */
var PageApplication___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageApplication___vue_module_identifier__ = null
var PageApplication_Component = PageApplication_normalizeComponent(
  PageApplication,
  pages_PageApplication,
  PageApplication___vue_template_functional__,
  PageApplication___vue_styles__,
  PageApplication___vue_scopeId__,
  PageApplication___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageApplication = (PageApplication_Component.exports);

// CONCATENATED MODULE: ./src/store/modules/user.js


// initial state
var state = {
  isLogin: false,
  user: {}

  // getters
};var getters = {
  isLogin: function isLogin(state) {
    return state.isLogin;
  }

  // actions
};var actions = {
  getUser: function getUser(_ref) {
    var commit = _ref.commit;

    vue_esm["a" /* default */].http.get('api/me').then(function (resp) {
      if (resp.data.errcode !== 0) {
        commit('setIsLogin', false);
      }
      commit('setIsLogin', true);
    });
  },
  setUser: function setUser(_ref2, user) {
    var commit = _ref2.commit;

    if (user) {
      commit('setIsLogin', true);
    } else {
      commit('setIsLogin', false);
    }
    commit('setUser', user);
  }
};

// mutations
var mutations = {
  setIsLogin: function setIsLogin(state, isLogin) {
    state.isLogin = isLogin;
  },
  setUser: function setUser(state, user) {
    state.user = user;
  }
};

/* harmony default export */ var user = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    navigation: [{
      name: '熊猫抓抓管理平台',
      url: '/home',
      logo: 'fa-dashboard'
    }, {
      name: '游戏设备管理',
      logo: 'fa-gamepad',
      childrens: [{
        name: '游戏房间管理',
        url: '/rooms'
      }, {
        name: '概率控制管理',
        url: '/rooms/trigger'
      }]
    }, {
      name: '订单管理',
      logo: 'fa-shopping-bag',
      childrens: [{
        name: '游戏订单',
        url: '/shop/orders'
      }, {
        name: '游戏记录',
        url: '/rooms/sessions'
      }]
    }, {
      name: '游戏玩家',
      logo: 'fa-user-plus',
      childrens: [{
        name: '玩家列表',
        url: '/gameusers'
      }, {
        name: '玩家游戏币流水',
        url: '/gameusers/coin/journal'
      }]
    }, {
      name: '账号管理',
      logo: 'fa-cogs',
      childrens: [{
        name: '密码修改',
        url: '/user/password'
      }, {
        name: '开放平台信息',
        url: '/application'
      }]
    }],
    pageData: {
      title: '',
      brief: '',
      pathlist: []
    }
  },
  mutations: {
    setPageData: function setPageData(state, pageData) {
      state.pageData = pageData;
    }
  },
  modules: {
    User: user
  },
  strict: debug,
  plugins: debug ? [] : []
}));
// CONCATENATED MODULE: ./src/router/index.js

















vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '*',
  component: src_pages_PageNotFound,
  meta: {
    layout: 'none',
    title: '404-页面丢了',
    bodyClass: 'layout-top-nav fixed'
  }
}, {
  path: '/',
  redirect: '/login'
}, {
  path: '/login',
  component: src_pages_PageIndex,
  meta: {
    layout: 'none',
    title: '登录',
    bodyClass: 'login-page'
  }
}, {
  path: '/home',
  component: src_pages_PageHome,
  meta: {}
}, {
  path: '/rooms',
  component: src_pages_PageRoomList,
  meta: {}
}, {
  path: '/rooms/trigger',
  component: src_pages_PageRoomTrigger,
  meta: {}
}, {
  path: '/shop/orders',
  component: src_pages_PageShopOrderList,
  meta: {}
}, {
  path: '/rooms/sessions',
  component: src_pages_PageRoomSession,
  meta: {}
}, {
  path: '/gameusers',
  component: src_pages_PageGameUserList,
  meta: {}
}, {
  path: '/gameusers/coin/journal',
  component: src_pages_PageGameUserCoinJournal,
  meta: {}
}, {
  path: '/user/password',
  component: src_pages_PageUserPassword,
  meta: {}
}, {
  path: '/application',
  component: src_pages_PageApplication,
  meta: {}
}];
var router = new vue_router_esm["a" /* default */]({
  base: '/shopadmin/',
  routes: routes
});
/**
 * 获取导航路径
 */
var getNavIndexPath = function getNavIndexPath(url, parentNav) {
  var onlyIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var paths = [];
  var childPaths = [];
  for (var i in parentNav) {
    var row = parentNav[i];
    var index = i;
    if (row.childrens !== undefined && row.childrens.length > 0) {
      // 搜索儿子
      childPaths = getNavIndexPath(url, row.childrens, onlyIndex);
      if (childPaths.length > 0) {
        if (onlyIndex) {
          paths.push(index);
        } else {
          paths.push(row);
        }
        paths = paths.concat(childPaths);
        break;
      }
    } else if (url === row.url) {
      if (onlyIndex) {
        paths.push(index);
      } else {
        paths.push(row);
      }
      break;
    }
  }
  return paths;
};
router.beforeEach(function (to, from, next) {
  if (!to.meta.title) {
    var paths = getNavIndexPath(to.path, store.state.navigation, false);
    to.meta.title = paths.pop().name;
  }
  if (!to.meta.layout) {
    to.meta.layout = 'main';
  }
  document.title = to.meta.title;
  if (!to.meta.bodyClass) {
    to.meta.bodyClass = 'sidebar-mini skin-yellow';
  }
  if (to.path === '/login' || store.state.User.isLogin && store.state.User.user) {
    next();
    return;
  }
  vue_esm["a" /* default */].http.get('/api/me').then(function (resp) {
    if (resp.data.errcode !== 0) {
      store.dispatch('setUser', null);
      next('/login');
      return;
    }
    store.dispatch('setUser', resp.data.user);
    next();
  }).catch(function (error) {
    console.log(error);
    store.dispatch('setUser', null);
    next('/login');
  });
});

router.beforeResolve(function (to, from, next) {
  /**
   * 根据路径设置页面基础数据
   */
  var setPageData = function setPageData(paths, parentNav) {
    var index = paths[0];
    if (paths.length <= 0) {
      return false;
    }
    if (paths.length === 1) {
      pageData.title = parentNav[index].name;
    } else if (paths.length > 1) {
      setPageData(paths.splice(1, paths.length - 1), parentNav[index].childrens);
    }
    pageData.pathlist.push(parentNav[index]);
  };
  var paths = getNavIndexPath(to.path, store.state.navigation);
  var pageData = { title: '', brief: '', pathlist: [] };
  setPageData(paths, store.state.navigation);
  pageData.pathlist = pageData.pathlist.reverse();
  store.commit('setPageData', pageData);
  next();
});
router.afterEach(function (to, from) {
  if (jquery_default.a.AdminLTE && jquery_default.a.AdminLTE.layout) {
    // nextTick 回调会在DOM更新完毕后再执行
    vue_esm["a" /* default */].nextTick(function () {
      jquery_default.a.AdminLTE.layout.activate();
    });
  }
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Layout = ({
  components: {
  },
  data: function data () {
    return {
    }
  },
  created: function created () {
  },
  mounted: function mounted () {
    jquery_default()('body').toggleClass('fixed');
    setTimeout(function () {
      jquery_default.a.AdminLTE.layout.fixSidebar();
      jquery_default.a.AdminLTE.pushMenu.expandOnHover();
      jquery_default.a.AdminLTE.layout.activate();
      jquery_default.a.AdminLTE.controlSidebar._fix(jquery_default()('.control-sidebar-bg'));
      jquery_default.a.AdminLTE.controlSidebar._fix(jquery_default()('.control-sidebar'));
    }, 1000);
    jquery_default()('body').on('shown.bs.modal', '.modal', function () {
      if (jquery_default()('body').width() <= 780 && jquery_default()('body').hasClass('sidebar-open')) {
        jquery_default()('.sidebar-toggle').trigger('click');
      }
    });
  },
  computed: Object.assign({}, {layout: function () {
      return this.$route.meta.layout === 'main'
    }},
    Object(vuex_esm["b" /* mapState */])({
      navigation: function (state) { return state.navigation; },
      user: function (state) { return state.User.user; }
    })),
  methods: {
    navClick: function navClick () {
      jquery_default()('.js-nav-li').removeClass('active');
      jquery_default()(event.currentTarget).addClass('active');
    }
  }
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b0e456","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
var Layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.layout)?_c('div',{staticClass:"wrapper"},[_c('header',{staticClass:"main-header"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/login"}},[_c('span',{staticClass:"logo-mini"},[_vm._v("WOW")]),_vm._v(" "),_c('span',{staticClass:"logo-lg"},[_vm._v("熊猫抓抓管理平台")])]),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-static-top"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-custom-menu"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('img',{staticClass:"user-image",attrs:{"src":__webpack_require__("zA3t"),"alt":"User Image"}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs"},[_vm._v(_vm._s(_vm.user.username))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"user-header"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("zA3t"),"alt":"User Image"}}),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.user.username)+"\n                  "),_c('small',[_vm._v("Just Do It")])])]),_vm._v(" "),_c('li',{staticClass:"user-body"}),_vm._v(" "),_vm._m(1)])])])])])],1),_vm._v(" "),_c('aside',{staticClass:"main-sidebar"},[_c('section',{staticClass:"sidebar"},[_c('div',{staticClass:"user-panel"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"pull-left info"},[_c('p',[_vm._v(_vm._s(_vm.user.username))]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('ul',{staticClass:"sidebar-menu"},[_c('li',{staticClass:"header"},[_vm._v("传送门")]),_vm._v(" "),_vm._l((_vm.navigation),function(nav){return (! nav.childrens)?_c('li',{staticClass:"js-nav-li",on:{"click":function($event){return _vm.navClick($event)}}},[_c('router-link',{attrs:{"to":nav.url}},[_c('i',{staticClass:"fa",class:nav.logo}),_vm._v(" "),_c('span',[_vm._v(_vm._s(nav.name))])])],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.navigation),function(nav){return (nav.childrens)?_c('li',{staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa",class:nav.logo}),_vm._v(" "),_c('span',[_vm._v(_vm._s(nav.name))]),_vm._v(" "),_vm._m(4,true)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},_vm._l((nav.childrens),function(children){return _c('li',{staticClass:"js-nav-li",on:{"click":function($event){return _vm.navClick($event)}}},[_c('router-link',{attrs:{"to":children.url}},[_c('i',{staticClass:"fa fa-circle-o"}),_vm._v(" "+_vm._s(children.name))])],1)}),0)]):_vm._e()})],2)])]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._m(5)],2):_vm._t("default")],2)}
var Layout_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidebar-toggle",attrs:{"href":"#","data-toggle":"offcanvas","role":"button"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"user-footer"},[_c('div',{staticClass:"pull-left"},[_c('a',{staticClass:"btn btn-default btn-flat",attrs:{"href":"#"}},[_vm._v("偏好")])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"btn btn-default btn-flat",attrs:{"href":"/logout"}},[_vm._v("退出登录")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-left image"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("zA3t"),"alt":"User Image"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-circle text-success"}),_vm._v(" 在线")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-tips js-alert-tips"},[_c('div',{staticClass:"inner-text"})])}]
var Layout_esExports = { render: Layout_render, staticRenderFns: Layout_staticRenderFns }
/* harmony default export */ var components_Layout = (Layout_esExports);
// CONCATENATED MODULE: ./src/components/Layout.vue
function Layout_injectStyle (ssrContext) {
  __webpack_require__("K2DY")
}
var Layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Layout___vue_template_functional__ = false
/* styles */
var Layout___vue_styles__ = Layout_injectStyle
/* scopeId */
var Layout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Layout___vue_module_identifier__ = null
var Layout_Component = Layout_normalizeComponent(
  Layout,
  components_Layout,
  Layout___vue_template_functional__,
  Layout___vue_styles__,
  Layout___vue_scopeId__,
  Layout___vue_module_identifier__
)

/* harmony default export */ var src_components_Layout = (Layout_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/cookie/index.js
var cookie = __webpack_require__("17Ff");

// EXTERNAL MODULE: ./node_modules/admin-lte/bootstrap/css/bootstrap.min.css
var bootstrap_min = __webpack_require__("PKtA");
var bootstrap_min_default = /*#__PURE__*/__webpack_require__.n(bootstrap_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/plugins/datatables/dataTables.bootstrap.css
var dataTables_bootstrap = __webpack_require__("k59n");
var dataTables_bootstrap_default = /*#__PURE__*/__webpack_require__.n(dataTables_bootstrap);

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("e0XP");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/dist/css/AdminLTE.min.css
var AdminLTE_min = __webpack_require__("R6CI");
var AdminLTE_min_default = /*#__PURE__*/__webpack_require__.n(AdminLTE_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/plugins/iCheck/square/_all.css
var _all = __webpack_require__("xS2n");
var _all_default = /*#__PURE__*/__webpack_require__.n(_all);

// EXTERNAL MODULE: ./node_modules/admin-lte/dist/css/skins/skin-yellow.min.css
var skin_yellow_min = __webpack_require__("wnpp");
var skin_yellow_min_default = /*#__PURE__*/__webpack_require__.n(skin_yellow_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/dist/css/skins/skin-blue.min.css
var skin_blue_min = __webpack_require__("PmN9");
var skin_blue_min_default = /*#__PURE__*/__webpack_require__.n(skin_blue_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/bootstrap/js/bootstrap.min.js
var js_bootstrap_min = __webpack_require__("UazT");
var js_bootstrap_min_default = /*#__PURE__*/__webpack_require__.n(js_bootstrap_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/plugins/iCheck/icheck.min.js
var icheck_min = __webpack_require__("hjx0");
var icheck_min_default = /*#__PURE__*/__webpack_require__.n(icheck_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/dist/js/app.min.js
var app_min = __webpack_require__("Umtp");
var app_min_default = /*#__PURE__*/__webpack_require__.n(app_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.min.js
var jquery_slimscroll_min = __webpack_require__("pWvC");
var jquery_slimscroll_min_default = /*#__PURE__*/__webpack_require__.n(jquery_slimscroll_min);

// EXTERNAL MODULE: ./node_modules/admin-lte/plugins/morris/morris.min.js
var morris_min = __webpack_require__("V9rZ");
var morris_min_default = /*#__PURE__*/__webpack_require__.n(morris_min);

// CONCATENATED MODULE: ../node_modules/buble-loader!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue




















/* harmony default export */ var App = ({
name: 'app',
components: {
Layout: src_components_Layout
},
created: function created () {
if (cookie["a" /* default */].get('XSRF-TOKEN') === undefined) {
window.location = '/xsrf';
}
},
mounted: function mounted () {
}
});

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31278fc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('router-view'),_vm._v(" "),_c('vue-progress-bar')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("+qgV")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// CONCATENATED MODULE: ./src/plugins/utils.js

/* harmony default export */ var utils = ({
  install: function install(Vue, options) {
    Vue.prototype.isHttps = function () {
      return window.location.protocol === 'https:';
    };
    Vue.prototype.serviceUrl = function (path) {
      return "https://open.wowgotcha.com/" + path;
    };
    Vue.prototype.pageUrl = function (path) {
      return '/' + this.$route.params.shopid + '/' + path;
    };
    Vue.prototype.cdnUrl = function (path) {
      return Object({"NODE_ENV":"production","DEBUG":false,"SERVICE_URL":"https://open.wowgotcha.com/"}).CDN_URL + '/' + path;
    };
    Vue.prototype.pageFn = function (page) {
      return 'javascript:void(0);';
    };
    Vue.prototype.dateRangePickerOptions = {
      timePicker: true,
      timePicker24Hour: true,
      timePickerIncrement: 1,
      timePickerSeconds: true,
      locale: {
        format: 'YYYY-MM-DD HH:mm:ss',
        applyLabel: '确定',
        cancelLabel: '清除',
        customRangeLabel: 'Custom',
        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        opens: 'left'
      }
    };
    Vue.prototype.dateTimePickerOptions = {
      singleDatePicker: true,
      showClear: true,
      locale: {
        format: 'YYYY-MM-DD',
        applyLabel: '确定',
        cancelLabel: '清除',
        customRangeLabel: 'Custom',
        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        opens: 'left'
      }
    };
    Vue.prototype.fadeIn = function (dom) {
      var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';

      dom.fadeIn(speed).removeClass('hidden').removeClass('hide');
    };
    Vue.prototype.alert = function (text) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var isAutoHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      // 自定义alert
      var $tips = jquery_default()('.js-alert-tips');
      var $textDom = $tips.find('.inner-text');
      var $classText = 'alert-info alert-danger';
      $textDom.html(text);
      $textDom.removeClass($classText);
      if (type === 1) {
        // success alert
        $textDom.addClass('alert-info');
      } else if (type === 2) {
        // danger alert
        $textDom.addClass('alert-danger');
      } else {
        $textDom.addClass('alert-info');
      }
      this.fadeIn($tips);
      if (isAutoHide !== false) {
        setTimeout(function () {
          $tips.fadeOut();
        }, 5000);
      }
    };
  }
});
// EXTERNAL MODULE: ./node_modules/vue-body-class/dist/index.js
var dist = __webpack_require__("yfhv");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-progressbar/dist/vue-progressbar.js
var vue_progressbar = __webpack_require__("zYko");
var vue_progressbar_default = /*#__PURE__*/__webpack_require__.n(vue_progressbar);

// CONCATENATED MODULE: ./src/main.js












vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].prototype.$http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
vue_esm["a" /* default */].use(utils);

var main_options = {
  color: '#2c3e50',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};
vue_esm["a" /* default */].use(vue_progressbar_default.a, main_options);

vue_esm["a" /* default */].prototype.$http.interceptors.request.use(function (config) {
  vue_esm["a" /* default */].prototype.$Progress.start();
  return config;
});
vue_esm["a" /* default */].prototype.$http.interceptors.response.use(function (response) {
  vue_esm["a" /* default */].prototype.$Progress.finish();
  return response;
});

var main_router = src_router;
vue_esm["a" /* default */].use(dist_default.a, main_router);

vue_esm["a" /* default */].config.productionTip = "production" !== 'production';

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: main_router,
  store: store,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-main');

/***/ }),

/***/ "PKtA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PmN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R6CI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VjOs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wqre":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XYxu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aSNA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dwQ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ffrA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqIx":
/***/ (function(module, exports) {

//
//
//
//
//
//
//

module.exports = {
  computed: {
    classObject: function () {
      return {
        active: this.active,
        hellip: this.hellip,
        disabled: this._disabled
      }
    },
    _disabled: function () {
      return this.disabled || this.hellip || (this.prev && this.p === 0)
    },
    _label: function () {
      if (this.hellip) {
        return '…'
      }
      if (this.prev) {
        return '«'
      }
      if (this.next) {
        return '»'
      }
      if (this.label) {
        return this.label
      }
      return this.p
    }
  },
  methods: {
    onClick: function () {
      this.$emit('click', this.p)
    },
    getAriaLabel: function () {
      if (this.prev) {
        return 'Previous'
      }
      if (this.next) {
        return 'Next'
      }
    },
    _pageFn: function (page) {
      if (typeof this.pageFn === 'function') {
        return this.pageFn(page)
      }
      return '#'
    }
  },
  props: [ 'p', 'disabled', 'active', 'label', 'next', 'prev', 'hellip', 'pageFn' ]
}


/***/ }),

/***/ "k59n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rgg/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sGdd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("G4wZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c22a5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("0aTy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__buble_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c22a5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "u5iF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("sGdd");

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vIuB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wnpp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xS2n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classObject},[(_vm._disabled)?_c('span',[_vm._v(_vm._s(_vm._label))]):_c('a',{attrs:{"href":_vm._pageFn(_vm.p),"aria-label":_vm.getAriaLabel()},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm._label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yHH8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yyNB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zA3t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avator.400a374.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.94475a98e0e53aa5fbd2.js